import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UsuarioService } from '../../services/usuario.service';
import { take } from 'rxjs/operators';
import { NgxSpinnerService } from "ngx-spinner";
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatStepper } from '@angular/material/stepper';
import { CancelarPedidoDialog } from '../dialogs/cancelar-pedido-dialog/cancelar-pedido-dialog';
import { AlterarFormaPagamentoDialog } from '../dialogs/alterar-forma-pagamento-dialog/alterar-forma-pagamento-dialog';
import * as firebase from 'firebase'; //Timestamp (firebase.default.database.ServerValue.TIMESTAMP)
import { SelectionModel } from '@angular/cdk/collections';

import { PedidoConsultaElement } from '../../interfaces/pedido.consulta';
import { AngularFireDatabase } from "@angular/fire/database";
import { MatDialog } from '@angular/material/dialog';
import { AlertaTipoImpressaoDialog } from '../dialogs/tipo-impressao-dialog/tipo-impressao-dialog';
import { RemoverProdutoDialog } from '../dialogs/remover-produtos-dialog/remover-produtos-dialog';

import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import { MapaLatlngClienteDialog } from '../dialogs/mapa-latlng-cliente-dialog/mapa-latlng-cliente-dialog.component';
import { RetornarStatusPedidoDialog } from '../dialogs/retornar-status-pedido-dialog/retornar-status-pedido-dialog.component';
import { AlterarStatusPedidoDemandaDialog } from '../dialogs/alterar-status-pedido-demanda-dialog/alterar-status-pedido-demanda-dialog';
import { GerarBoletoDemandaDialog } from '../../modules/dialogs/gerar-boleto-demanda-dialog/gerar-boleto-demanda-dialog';
import { AlterarPagamentosDemandaDialog } from '../dialogs/confirmar-pagamento-dialog/confirmar-pagamento-dialog';
import { GerarBoletoDialog } from '../dialogs/gerar-boleto-dialog/gerar-boleto-dialog';
import { CancelarBoletoDialog } from '../dialogs/cancelar-boleto-dialog/cancelar-boleto-dialog';
import { SicoobService } from '../../services/sicoob';
import funcoesGerais from '../../funcoes/funcoesGerais';
import { GerarCanhotosDialog } from '../dialogs/gerar-canhotos-dialog/gerar-canhotos-dialog';
import { StatusGerarBoleto } from '../../interfaces/sicoob/erroGerarBoleto';
import { RespostaSicoobBoletoBaixa } from '../../interfaces/sicoob/respostaSicoobBoletoBaixa';
import { gerarMapBoletoBaixa } from '../../../environments/sicoob';
import { ConsultaBoleto } from '../../interfaces/consultaBoleto';
import { TokenSicoob } from '../../interfaces/sicoob/token';

var pointInPolygon = require('point-in-polygon');

@Component({
  selector: 'app-consultar-pedidos',
  templateUrl: './consultar-pedidos.component.html',
  styleUrls: ['./consultar-pedidos.component.scss', '../../styles/estilo.padrao.scss']
})
export class ConsultarPedidoComponent implements OnInit {
  @ViewChild('stepper') stepper: MatStepper;

  uid;
  bConsulta: boolean = false;
  bRemoverProdutosCancelarPedido: boolean = false;
  pedidoForm: FormGroup;
  range: FormGroup;
  datePickerRotaControl: FormControl;

  bBloquearClickTabela: Boolean = true;
  iconeCadeado: string = 'lock_open';

  sTipoBusca: String = 'Período';
  idPedido: number;
  aTipoStatus: any[] = [];
  aTiposBusca: any[] = [
    { value: 'Período', name: 'Período' },
    { value: 'Rota', name: 'Rota' },
    { value: 'IDPedido', name: 'Número do pedido' },
  ];

  sBuscaStatusPedido: string = 'Todos';
  aTiposBuscaStatusPedido: any[] = [
    { value: 'Todos', name: 'Todos' },
    { value: 'Confirmado', name: 'Confirmados' },
    { value: 'Em separação', name: 'Em separação' },
    { value: 'Em rota', name: 'Em rota' },
    { value: 'Entregue', name: 'Entregue' },
    { value: 'Cancelado', name: 'Cancelados' },
  ];

  sBuscaStatusPagamento: string = 'Todas';
  aTiposStatusPagamento: any[] = [
    { value: 'Todas', name: 'Todas' },
    { value: 'Pendente', name: 'Pendente' },
    { value: 'Pago', name: 'Pagos' },
    { value: 'Cancelado', name: 'Cancelados' },
  ];

  sTipoImpressao: string = 'Lista produtos';
  aTipoImpressao: any[] = [
    { value: 0, name: 'Lista produtos' },
    { value: 1, name: 'Lote' },
    { value: 2, name: 'Relação pedidos' },
    { value: 3, name: 'Boletos' },
    { value: 4, name: 'Canhotos recibos' },
  ]

  sBuscaCidade: string = 'Todas';
  aCidades: any[] = [];

  auxTodasCidadesSistema = [];
  sBuscaIDPoligono: string = 'Todas';
  poligonoSelecionado: any = [];
  aRotas: any[] = [];

  maxDate: Date = new Date();
  today: Date = new Date();

  displayedColumns: string[] = ['select', 'ID', 'Rota', 'Nome', 'Status', 'StatusPagamento', 'Cidade', 'DataHora', 'SomaCorreta', 'Consultar'];
  pedidosSource = new MatTableDataSource<any>([]);;
  selection = new SelectionModel<any>(true, []);

  $pedidos;
  pedidoSelecionado: PedidoConsultaElement; //Caso o boleto seja gerado dentro do pedido (com valor diferente), já obter uma cópia em um objeto.
  date: Date = new Date();

  bPaginaCarregada: boolean = false;

  pageIndex = 0;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  tokenSicoob: TokenSicoob;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private toastr: ToastrService,
    private usuarioService: UsuarioService,
    private spinner: NgxSpinnerService,
    private activeRoute: ActivatedRoute,
    private db: AngularFireDatabase,
    private dialog: MatDialog,
    private sicoobService: SicoobService

  ) {
    this.uid = localStorage.getItem('uid');
    this.spinner.show('consultar-pedidos');

    this.activeRoute.queryParams.subscribe(params => {
      let numeroPedido = params['numeroPedido'];
      numeroPedido && !this.bPaginaCarregada ? this.buscarPedidoPorNumero(numeroPedido) : setTimeout(() => this.buscarPedidosPeriodo(), 200);
    });
  }

  ngOnInit(): void {
    this.bPaginaCarregada = true;

    this.range = new FormGroup({
      start: new FormControl(),
      end: new FormControl()
    });
    this.datePickerRotaControl = new FormControl(new Date());

    //Recupera as rotas para realizar filtros;
    this.usuarioService.getCidades(this.uid).pipe(take(1)).subscribe(snap => {
      this.auxTodasCidadesSistema = [];

      if (snap.length > 0) {
        var dados;
        var auxDadosCidade;

        snap.forEach((item, index) => {
          dados = item.payload.val();

          Object.keys(dados).forEach((key, index) => {
            auxDadosCidade = dados[key];
            if (auxDadosCidade.Status) {
              this.auxTodasCidadesSistema.push({
                uf: item.key,
                value: key,
                name: auxDadosCidade.Cidade
              })
            }
          });
        });

        this.auxTodasCidadesSistema.sort((a, b) => a.name.localeCompare(b.name));

        this.usuarioService.getTodasRotas().pipe(take(1)).subscribe(snap => {
          this.aRotas = [];

          if (snap.length > 0) {
            var dados;
            var auxDadosRota;
            let auxIndexCidade;

            snap.forEach((item, index) => {
              dados = item.payload.val();


              Object.keys(dados).forEach((key, index) => {
                auxDadosRota = dados[key];
                auxIndexCidade = this.auxTodasCidadesSistema.findIndex(x => x.value === item.key);

                this.aRotas.push({
                  idCidade: item.key,
                  idPoligono: key,
                  poligonos: auxDadosRota.Area,
                  nomeCidade: auxDadosRota.Nome,
                  stringCidade: this.auxTodasCidadesSistema[auxIndexCidade]?.name + '/' + this.auxTodasCidadesSistema[auxIndexCidade]?.uf,
                });
              });
            });

            //Ordena alfabeticamente
            this.aRotas.sort((a, b) => a.idCidade.localeCompare(b.idCidade));
            this.aRotas.unshift({ idCidade: 'Todas', idPoligono: 'Todas', poligonos: "[]", nomeCidade: 'Todas', stringCidade: 'No período definido' });
          }

          setTimeout(() => this.spinner.hide('consultar-pedidos'), 300);

        });
      }
    });

    const dataSalva = JSON.parse(localStorage.getItem('periodo_busca_pedidos'));

    if (dataSalva && dataSalva.DataSalva === this.usuarioService.tratarData(new Date().getTime())) {
      this.range.get('start').patchValue(new Date(dataSalva.TimestampInicio));
      this.range.get('end').patchValue(new Date(dataSalva.TimestampFinal));
      this.pageIndex = Number(localStorage.getItem('pageIndex'));
      this.sTipoBusca = localStorage.getItem('tipoBuscaSelect') ? localStorage.getItem('tipoBuscaSelect') : 'Período';
      this.changeSelect(); // para validar a data máxima;


      //Limita o período selecionado à 40 dias
      let auxDate = new Date(new Date(dataSalva.TimestampInicio));
      auxDate.setDate(auxDate.getDate() + 40);

      if (auxDate.getTime() < this.today.getTime()) {
        this.maxDate = auxDate;
      } else {
        this.maxDate = this.today;
      }

    } else {
      this.range.get('start').patchValue(new Date());
      this.range.get('end').patchValue(new Date());
      this.pageIndex = 0;
    }

    this.pedidoForm = this.formBuilder.group({
      id: ['', null],
      bairro: ['', null],
      bandeiraCartao: ['', null],
      srcImagemCartao: ['', null],
      cep: ['', null],
      cidade: ['', null],
      complemento: ['', null],
      email: ['', null],
      formaPagamento: ['', null],
      idUsuario: ['', null],
      idVendedor: ['', null],
      nomeVendedor: ['', null],
      logradouro: ['', null],
      nome: ['', null],
      numero: ['', null],
      observacao: ['', null],
      produtos: [[], null],
      referencia: ['', null],
      status: ['', null],
      statusPagamento: ['', null],
      telefone: ['', null],
      telefoneSecundario: ['', null],
      timestamp: ['', null],
      total: ['', null],
      uf: ['', null],
      valorCentavosString: ['', null],
      valorRealString: ['', null],
      data: ['', null],
      hora: ['', null],
      dataSeparacao: ['', null],
      horaSeparacao: ['', null],
      dataRota: ['', null],
      horaRota: ['', null],
      dataEntregue: ['', null],
      horaEntregue: ['', null],
      dataCancelado: ['', null],
      horaCancelado: ['', null],
      motivoCancelamento: ['', null],
      statusSelect: ['', null],
      dataHoraPagamentoPagoCancelado: ['', null],
      responsavelCompra: ['', null],
      dispositivo: ['', null],
      plataforma: ['', null],
      numeroParcelas: ['', null],
      prazoBoleto: ['', null],
      idDispositivo: ['', null],
      versaoSistema: ['', null],
      nomeRota: ['', null],
      latitude: ['', null],
      longitude: ['', null],
      prazoNota: ['', null],
      statusBoleto: ['', null],
      pdfBase64: ['', null],
      pdfBase64Parcela2: ['', null],
      observacaoBoleto: ['', null],
      observacaoBoleto2: ['', null],
      valorBoleto: [null, null],
      vencimentoBoleto: [null, null],
      valorBoleto2: [null, null],
      vencimentoBoleto2: [null, null],
      idBoleto: ['', null],
      idBoleto2: ['', null],
      valorDescontoVoucher: ['', null],
      valorDesconto: ['', null],
      porcentagemDesconto: ['', null],
    });
  }

  ngOnDestroy() {
    this.$pedidos = null;
  }

  //Limita o período selecionado à 40 dias
  dateChanged(event) {
    let auxDate = new Date(event.value);
    auxDate.setDate(auxDate.getDate() + 40);

    if (auxDate.getTime() < this.today.getTime()) {
      this.maxDate = auxDate;
    } else
      if (this.sTipoBusca !== 'Rota') {
        this.maxDate = this.today;
      }
  }

  buscarPedidoPorNumero(numero) {
    if (numero) {
      this.usuarioService.getPedidoPorNumero(numero).pipe(take(1)).subscribe((snap: any) => {

        if (snap.payload.exists()) {
          let auxPedido: PedidoConsultaElement;
          var dados;

          dados = snap.payload.val();

          console.log(dados)
          auxPedido = ({
            ID: snap.key,
            Bairro: dados.Bairro,
            BandeiraCartao: dados.BandeiraCartao,
            CEP: dados.CEP,
            Cidade: dados.Cidade,
            Complemento: dados.Complemento,
            Email: dados.Email,
            FormaPagamento: dados.FormaPagamento,
            IDUsuario: dados.IDUsuario,
            IDVendedor: dados.IDVendedor,
            IDDispositivo: dados.IDDispositivo ? dados.IDDispositivo : '',
            Logradouro: dados.Logradouro,
            Nome: dados.Nome,
            Numero: dados.Numero,
            Observacao: dados.Observacao,
            Produtos: dados.Produtos,
            Referencia: dados.Referencia,
            Status: dados.Status,
            StatusPagamento: dados.StatusPagamento,
            Telefone: dados.Telefone,
            TelefoneSecundario: dados.TelefoneSecundario,
            Timestamp: dados.Timestamp,
            TimestampPagamento: dados.TimestampPagamento ? dados.TimestampPagamento : false,
            TimestampSeparacao: dados.TimestampSeparacao ? dados.TimestampSeparacao : 0,
            TimestampRota: dados.TimestampRota ? dados.TimestampRota : 0,
            TimestampEntregue: dados.TimestampEntregue ? dados.TimestampEntregue : 0,
            TimestampCancelado: dados.TimestampCancelado ? dados.TimestampCancelado : 0,
            TimestampPrevisaoRota: dados.TimestampPrevisaoRota ? dados.TimestampPrevisaoRota : false,
            Total: dados.Total,
            UF: dados.UF,
            ValorCentavosString: dados.ValorCentavosString,
            ValorRealString: dados.ValorRealString,
            Data: this.usuarioService.tratarData(dados.Timestamp),
            Hora: this.usuarioService.tratarHora(dados.Timestamp),
            DataSeparacao: dados.TimestampSeparacao ? this.usuarioService.tratarData(dados.TimestampSeparacao) : '',
            HoraSeparacao: dados.TimestampSeparacao ? this.usuarioService.tratarHora(dados.TimestampSeparacao) : '',
            DataRota: dados.TimestampRota ? this.usuarioService.tratarData(dados.TimestampRota) : '',
            HoraRota: dados.TimestampRota ? this.usuarioService.tratarHora(dados.TimestampRota) : '',
            DataEntregue: dados.TimestampEntregue ? this.usuarioService.tratarData(dados.TimestampEntregue) : '',
            HoraEntregue: dados.TimestampEntregue ? this.usuarioService.tratarHora(dados.TimestampEntregue) : '',
            DataCancelado: dados.TimestampCancelado ? this.usuarioService.tratarData(dados.TimestampCancelado) : '',
            HoraCancelado: dados.TimestampCancelado ? this.usuarioService.tratarHora(dados.TimestampCancelado) : '',
            MotivoCancelamento: dados.MotivoCancelamento ? dados.MotivoCancelamento : '',
            DataHoraPagamento: dados.TimestampPagamento ? this.usuarioService.tratarDataHora(dados.TimestampPagamento) : '',
            FiltroStatusPedidoPagamentoCidade: '',
            FiltroStatusPedidoCidade: '',
            Dispositivo: dados.Dispositivo ? dados.Dispositivo : 'Computador',
            Plataforma: dados.Plataforma,
            NumeroParcelas: dados.NumeroParcelas,
            PrazoBoleto: dados.PrazoBoleto,
            IDRota: dados.IDRota,
            NomeRota: dados.NomeRota,
            IDCidade: dados.IDCidade,
            VersaoSistema: dados.VersaoSistema ? dados.VersaoSistema : false,
            Latitude: dados.Latitude,
            Longitude: dados.Longitude,
            CPF: false,
            CNPJ: false,
            PrazoNota: dados.PrazoNota,
            SomaCorreta: this.calcularSomaCompra(dados.Produtos, dados.Total, snap.key, (dados.ValorDescontoVoucher ?? 0) + (dados.Desconto ? dados.Desconto : 0)),
            StatusBoleto: dados.StatusBoleto,
            PDFbase64: dados.PDFbase64,
            PDFbase64Parcela2: dados.PDFbase64Parcela2,
            TimestampVencimento: dados.TimestampVencimento,
            TimestampVencimento2: dados.TimestampVencimento2,
            ObservacaoBoleto: dados.ObservacaoBoleto,
            ObservacaoBoleto2: dados.ObservacaoBoleto2,
            ValorBoleto: dados.ValorBoleto,
            ValorBoleto2: dados.ValorBoleto2,
            IDBoleto: dados.IDBoleto,
            IDBoleto2: dados.IDBoleto2,
            ValorDescontoVoucher: dados.ValorDescontoVoucher ? dados.ValorDescontoVoucher : false,
            ValorDesconto: dados.ValorDesconto ?? 0,
            Desconto: dados.Desconto ? dados.Desconto : 0,
            PorcentagemDesconto: dados.PorcentagemDesconto ? dados.PorcentagemDesconto.toFixed(2) : 0
          });
          this.usuarioService.setLog("Consulta de pedido número: " + numero, null, this.uid);

          this.consultarSolicitacao(auxPedido)

          setTimeout(() => this.spinner.hide('consultar-pedidos'), 300);
        } else {
          this.toastr.error("Não foi possível localizar o pedido!", 'Erro');
          setTimeout(() => this.spinner.hide('consultar-pedidos'), 300);

          this.voltar();
        }
      });
    }
  }

  buscarPedidosPeriodo() {

    this.spinner.show('consultar-pedidos');

    switch (this.sTipoBusca) {
      case 'Período':
      case 'Rota':
        this.selection = new SelectionModel<any>(true, []);

        let timestampInicio: Date = new Date(this.range.get('start').value);
        timestampInicio.setHours(0);
        timestampInicio.setMinutes(0);
        timestampInicio.setSeconds(0);
        timestampInicio.setMilliseconds(0);

        let timestampFinal: Date = new Date(this.range.get('end').value);
        timestampFinal.setHours(23);
        timestampFinal.setMinutes(59);
        timestampFinal.setSeconds(59);
        timestampFinal.setMilliseconds(999);
        var difference = (timestampInicio.getFullYear() * 12 + timestampInicio.getMonth()) - (timestampFinal.getFullYear() * 12 + timestampFinal.getMonth());

        localStorage.setItem("periodo_busca_pedidos", JSON.stringify({
          DataSalva: this.usuarioService.tratarData(new Date().getTime()),
          TimestampInicio: timestampInicio.getTime(),
          TimestampFinal: timestampFinal.getTime()
        }));


        if (difference >= -12) {
          this.sBuscaCidade = 'Todas';
          this.sBuscaStatusPagamento = 'Todas';
          this.sBuscaStatusPedido = 'Todos';

          this.$pedidos = this.usuarioService.getPedidosTimestamp(timestampInicio.getTime(), timestampFinal.getTime(), this.sTipoBusca).subscribe(snap => {
            this.pedidosSource = new MatTableDataSource<any>([]);

            let auxCidades = [];

            if (snap.length > 0) {
              let auxPedidos: PedidoConsultaElement[] = [];
              snap.forEach((item, index) => {
                const dados: any = item.payload.val();

                if (this.validarFiltro(this.sTipoBusca, timestampInicio.getTime(), timestampFinal.getTime(), dados.TimestampPrevisaoRota, dados.IDRota, dados.Latitude, dados.Longitude)) {
                  console.log(item.key)
                  auxPedidos.push({
                    ID: item.key,
                    Bairro: dados.Bairro,
                    BandeiraCartao: dados.BandeiraCartao,
                    CEP: dados.CEP,
                    Cidade: dados.Cidade,
                    Complemento: dados.Complemento,
                    Email: dados.Email,
                    FormaPagamento: dados.FormaPagamento,
                    IDUsuario: dados.IDUsuario,
                    IDVendedor: dados.IDVendedor,
                    IDDispositivo: dados.IDDispositivo ? dados.IDDispositivo : '',
                    Logradouro: dados.Logradouro,
                    Nome: dados.Nome,
                    Numero: dados.Numero,
                    Observacao: dados.Observacao,
                    Produtos: dados.Produtos,
                    Referencia: dados.Referencia,
                    Status: dados.Status,
                    StatusPagamento: dados.StatusPagamento,
                    Telefone: dados.Telefone,
                    TelefoneSecundario: dados.TelefoneSecundario,
                    Timestamp: dados.Timestamp,
                    TimestampPagamento: dados.TimestampPagamento ? dados.TimestampPagamento : false,
                    TimestampSeparacao: dados.TimestampSeparacao ? dados.TimestampSeparacao : 0,
                    TimestampRota: dados.TimestampRota ? dados.TimestampRota : 0,
                    TimestampEntregue: dados.TimestampEntregue ? dados.TimestampEntregue : 0,
                    TimestampCancelado: dados.TimestampCancelado ? dados.TimestampCancelado : 0,
                    TimestampPrevisaoRota: dados.TimestampPrevisaoRota ? dados.TimestampPrevisaoRota : false,
                    Total: dados.Total,
                    UF: dados.UF,
                    ValorCentavosString: dados.ValorCentavosString,
                    ValorRealString: dados.ValorRealString,
                    Data: this.usuarioService.tratarData(dados.Timestamp),
                    Hora: this.usuarioService.tratarHora(dados.Timestamp),
                    DataSeparacao: dados.TimestampSeparacao ? this.usuarioService.tratarData(dados.TimestampSeparacao) : '',
                    HoraSeparacao: dados.TimestampSeparacao ? this.usuarioService.tratarHora(dados.TimestampSeparacao) : '',
                    DataRota: dados.TimestampRota ? this.usuarioService.tratarData(dados.TimestampRota) : '',
                    HoraRota: dados.TimestampRota ? this.usuarioService.tratarHora(dados.TimestampRota) : '',
                    DataEntregue: dados.TimestampEntregue ? this.usuarioService.tratarData(dados.TimestampEntregue) : '',
                    HoraEntregue: dados.TimestampEntregue ? this.usuarioService.tratarHora(dados.TimestampEntregue) : '',
                    DataCancelado: dados.TimestampCancelado ? this.usuarioService.tratarData(dados.TimestampCancelado) : '',
                    HoraCancelado: dados.TimestampCancelado ? this.usuarioService.tratarHora(dados.TimestampCancelado) : '',
                    MotivoCancelamento: dados.MotivoCancelamento ? dados.MotivoCancelamento : '',
                    DataHoraPagamento: dados.TimestampPagamento ? this.usuarioService.tratarDataHora(dados.TimestampPagamento) : '',
                    FiltroStatusPedidoPagamentoCidade: dados.Status.toLowerCase() + dados.StatusPagamento.toLowerCase() + dados.Cidade.toLowerCase(),
                    FiltroStatusPedidoCidade: dados.Status.toLowerCase() + dados.Cidade.toLowerCase(),
                    Dispositivo: dados.Dispositivo ? dados.Dispositivo : 'Computador',
                    Plataforma: dados.Plataforma,
                    NumeroParcelas: dados.NumeroParcelas,
                    PrazoNota: dados.PrazoNota,
                    PrazoBoleto: dados.PrazoBoleto,
                    IDRota: dados.IDRota,
                    NomeRota: dados.NomeRota,
                    IDCidade: dados.IDCidade,
                    VersaoSistema: dados.VersaoSistema ? dados.VersaoSistema : false,
                    Latitude: dados.Latitude,
                    Longitude: dados.Longitude,
                    CPF: false,
                    CNPJ: false,
                    // SomaCorreta: 'OK'
                    SomaCorreta: this.calcularSomaCompra(dados.Produtos, dados.Total, item.key, (dados.ValorDescontoVoucher ?? 0) + (dados.Desconto ? dados.Desconto : 0)),
                    StatusBoleto: dados.StatusBoleto,
                    PDFbase64: dados.PDFbase64,
                    PDFbase64Parcela2: dados.PDFbase64Parcela2,
                    TimestampVencimento: dados.TimestampVencimento,
                    TimestampVencimento2: dados.TimestampVencimento2,
                    ObservacaoBoleto: dados.ObservacaoBoleto,
                    ObservacaoBoleto2: dados.ObservacaoBoleto2,
                    ValorBoleto: dados.ValorBoleto,
                    ValorBoleto2: dados.ValorBoleto2,
                    IDBoleto: dados.IDBoleto,
                    IDBoleto2: dados.IDBoleto2,
                    ValorDescontoVoucher: dados.ValorDescontoVoucher ? dados.ValorDescontoVoucher : false,
                    ValorDesconto: dados.ValorDesconto ?? 0,
                    Desconto: dados.Desconto ? dados.Desconto : 0,
                    PorcentagemDesconto: dados.PorcentagemDesconto ? dados.PorcentagemDesconto.toFixed(2) : 0
                  });


                  auxCidades.findIndex(x => x.name == dados.Cidade) === -1 ? auxCidades.push({ value: dados.Cidade, name: dados.Cidade }) : null;
                }
              });


              auxCidades.sort((a, b) => a.name.localeCompare(b.name));
              this.aCidades = auxCidades;
              this.aCidades.unshift({ value: 'Todas', name: 'Todas' })


              auxPedidos = auxPedidos.reverse();

              // this.usuarioService.setLog("Consulta geral de pedidos inicio: " + timestampInicio.getTime() + " fim: " + timestampFinal.getTime(), null, this.uid);

              this.pedidosSource = new MatTableDataSource(auxPedidos);
              this.pedidosSource.paginator = this.paginator;

              setTimeout(() => this.spinner.hide('consultar-pedidos'), 300);
            } else {
              // this.toastr.error("Não foi possível localizar pedidos!", 'Erro');
              setTimeout(() => this.spinner.hide('consultar-pedidos'), 300);
            }
          });
        } else {
          this.toastr.warning('Não é possível realizar um filtro acima de 12 meses!', 'Status', { progressBar: true, positionClass: 'toast-top-center', });
          setTimeout(() => this.spinner.hide('consultar-pedidos'), 300);
        }
        break;

      case 'IDPedido':
        this.buscarPedidoPorNumero(this.idPedido);
        break;

      default:
        this.toastr.error('Nenhuma solicitação recebida!', 'Status', { progressBar: true, positionClass: 'toast-top-center', });
        setTimeout(() => this.spinner.hide('consultar-pedidos'), 300);
        break;
    }
  }

  calcularSomaCompra(produtos: any, total: number, idPedido: string, valorDesconto: number | false) {
    total = Number(total.toFixed(2));
    console.log(' total: ' + total)
    console.log(' valorDesconto: ' + valorDesconto)
    try {
      let soma = 0;
      for (let pd of produtos) {
        if (!pd.DescontoGrupoPromocional) {
          soma += (pd.Valor * pd.QuantidadeComprada)
        } else {
          soma += (pd.ValorDesconto * pd.QuantidadeComprada)
        }
      }

      if (valorDesconto) {
        total = Number((total + valorDesconto).toFixed(2));

        // if (total === 0)
        //   total = valorDesconto;
      }

      soma = Number(soma.toFixed(2));
      if (soma != total) {
        console.log(produtos)
        console.log(idPedido)
        console.log('Soma: ' + soma)
        console.log('total: ' + total)
        console.log('-----')
      }

      return soma == total ? 'OK' : 'ERRADA';
    } catch (error) {
      console.log(error)
      return 'ERRADA';
    }
  }


  // Finalizar consulta por rota (após trocar o cadastro das rotas)
  validarFiltro(tipo, timestampInicio, timestampFinal, timestampPrevisaoRota, idRotaPedido, latitude, longitude) {
    switch (tipo) {
      case 'Período':
        return true;

      case 'Rota':
        if (timestampInicio <= timestampPrevisaoRota && timestampFinal >= timestampPrevisaoRota) {
          if (this.sBuscaIDPoligono !== 'Todas') {
            if (this.sBuscaIDPoligono === idRotaPedido) {
              return pointInPolygon([latitude, longitude], this.poligonoSelecionado) ? true : false;
            } else
              return false;
          } else
            return true;
        } else
          return false;

      default: return false;
    }
  }

  consultarSolicitacao(dados: any) {
    if (this.bBloquearClickTabela) {
      this.pedidoSelecionado = dados;
      this.spinner.show('consultar-pedidos');
      this.bConsulta = true;

      console.log(dados)
      this.usuarioService.setLog("Consulta detalhada pedido: " + dados.ID + ' Cliente: ' + dados.Nome + ' ' + dados.IDCliente, null, this.uid);

      this.pedidoForm.get('id').patchValue(dados.ID);
      this.pedidoForm.get('bairro').patchValue(dados.Bairro);
      this.pedidoForm.get('bandeiraCartao').patchValue(dados.BandeiraCartao);
      this.pedidoForm.get('cep').patchValue(dados.CEP);
      this.pedidoForm.get('cidade').patchValue(dados.Cidade);
      this.pedidoForm.get('complemento').patchValue(dados.Complemento);
      this.pedidoForm.get('email').patchValue(dados.Email);
      this.pedidoForm.get('formaPagamento').patchValue(dados.FormaPagamento);
      this.pedidoForm.get('idUsuario').patchValue(dados.IDUsuario);
      this.pedidoForm.get('idVendedor').patchValue(dados.IDVendedor);
      this.pedidoForm.get('logradouro').patchValue(dados.Logradouro);
      this.pedidoForm.get('nome').patchValue(dados.Nome);
      this.pedidoForm.get('numero').patchValue(dados.Numero);
      this.pedidoForm.get('observacao').patchValue(dados.Observacao);
      // this.pedidoForm.get('produtos').patchValue(dados.Produtos);
      this.pedidoForm.get('referencia').patchValue(dados.Referencia);
      this.pedidoForm.get('status').patchValue(dados.Status);
      this.pedidoForm.get('statusPagamento').patchValue(dados.StatusPagamento);
      this.pedidoForm.get('telefone').patchValue(dados.Telefone);
      this.pedidoForm.get('telefoneSecundario').patchValue(dados.TelefoneSecundario);
      this.pedidoForm.get('timestamp').patchValue(dados.Timestamp);
      this.pedidoForm.get('total').patchValue(dados.Total);
      this.pedidoForm.get('uf').patchValue(dados.UF);
      this.pedidoForm.get('valorCentavosString').patchValue(dados.ValorCentavosString);
      this.pedidoForm.get('valorRealString').patchValue(dados.ValorRealString);
      this.pedidoForm.get('data').patchValue(dados.Data);
      this.pedidoForm.get('hora').patchValue(dados.Hora);
      this.pedidoForm.get('dataSeparacao').patchValue(dados.DataSeparacao);
      this.pedidoForm.get('horaSeparacao').patchValue(dados.HoraSeparacao);
      this.pedidoForm.get('dataRota').patchValue(dados.DataRota);
      this.pedidoForm.get('horaRota').patchValue(dados.HoraRota);
      this.pedidoForm.get('dataEntregue').patchValue(dados.DataEntregue);
      this.pedidoForm.get('horaEntregue').patchValue(dados.HoraEntregue);
      this.pedidoForm.get('dataCancelado').patchValue(dados.DataCancelado);
      this.pedidoForm.get('horaCancelado').patchValue(dados.HoraCancelado);
      this.pedidoForm.get('motivoCancelamento').patchValue(dados.MotivoCancelamento);
      this.pedidoForm.get('dataHoraPagamentoPagoCancelado').patchValue(dados.DataHoraPagamento);
      this.pedidoForm.get('dispositivo').patchValue(dados.Dispositivo);
      this.pedidoForm.get('plataforma').patchValue(dados.Plataforma);
      this.pedidoForm.get('numeroParcelas').patchValue(dados.NumeroParcelas);
      this.pedidoForm.get('prazoBoleto').patchValue(dados.PrazoBoleto);
      this.pedidoForm.get('idDispositivo').patchValue(dados.IDDispositivo);
      this.pedidoForm.get('versaoSistema').patchValue(dados.VersaoSistema ? dados.VersaoSistema : 'não informado');
      this.pedidoForm.get('nomeRota').patchValue(dados.IDRota ? dados.NomeRota : false);
      this.pedidoForm.get('latitude').patchValue(dados.Latitude ? dados.Latitude : false);
      this.pedidoForm.get('longitude').patchValue(dados.Longitude ? dados.Longitude : false);
      this.pedidoForm.get('prazoNota').patchValue(dados.PrazoNota);
      this.pedidoForm.get('statusBoleto').patchValue(dados.StatusBoleto);
      this.pedidoForm.get('pdfBase64').patchValue(dados.PDFbase64);
      this.pedidoForm.get('pdfBase64Parcela2').patchValue(dados.PDFbase64Parcela2);
      this.pedidoForm.get('observacaoBoleto').patchValue(dados.ObservacaoBoleto);
      this.pedidoForm.get('observacaoBoleto2').patchValue(dados.ObservacaoBoleto2);
      this.pedidoForm.get('valorBoleto').patchValue(dados.ValorBoleto ? `R$ ${dados.ValorBoleto.toFixed(2).replace('.', ',')}` : '-');
      this.pedidoForm.get('valorBoleto2').patchValue(dados.ValorBoleto2 ? `R$ ${dados.ValorBoleto2.toFixed(2).replace('.', ',')}` : '-');
      this.pedidoForm.get('vencimentoBoleto').patchValue(dados.TimestampVencimento ? funcoesGerais.tratarData(dados.TimestampVencimento) : '-');
      this.pedidoForm.get('vencimentoBoleto2').patchValue(dados.TimestampVencimento2 ? funcoesGerais.tratarData(dados.TimestampVencimento2) : '-');
      this.pedidoForm.get('idBoleto').patchValue(dados.IDBoleto);
      this.pedidoForm.get('idBoleto2').patchValue(dados.IDBoleto2);
      this.pedidoForm.get('valorDescontoVoucher').patchValue(dados.ValorDescontoVoucher);
      this.pedidoForm.get('valorDesconto').patchValue(dados.Desconto ? dados.Desconto : 0);
      this.pedidoForm.get('porcentagemDesconto').patchValue(dados.PorcentagemDesconto ? dados.PorcentagemDesconto : 0);

      let auxDate = new Date();
      auxDate.setDate(auxDate.getDate() - 30); // Valida se não se passaram 30 dias
      if (new Date(dados.Timestamp).getTime() >= auxDate.getTime()) {
        //Verifica se a comissão referente à este pedido já foi fechada.
        auxDate = new Date(); //Retorna ao mês atual, para verificar se há a comissão gerada ou não
        this.usuarioService.getComissao(this.usuarioService.tratarMesDataComSomaMes(auxDate.getTime())).pipe(take(1)).subscribe(snap => {
          snap.length === 0 ? this.bRemoverProdutosCancelarPedido = true : this.bRemoverProdutosCancelarPedido = false;
        });
      }

      setTimeout(() => {
        switch (dados.StatusPagamento) {
          case 'Pendente':
            document.getElementById('status_pagamento').style.color = '#FF8C00';
            break;

          case 'Pago':
            document.getElementById('status_pagamento').style.color = '#006400';
            break;

          case 'Cancelado':
            document.getElementById('status_pagamento').style.color = 'red';
            break;
        }
      }, 10);

      if (dados.TimestampPrevisaoRota || dados.Status === 'Cancelado') {
        this.datePickerRotaControl.patchValue(new Date(dados.TimestampPrevisaoRota));
        dados.Status === 'Em rota' || dados.Status === 'Cancelado' || dados.Status === 'Entregue' ? this.datePickerRotaControl.disable() : null;
      } else {
        let auxDate = new Date();
        auxDate.setDate(new Date().getDate() + 1);
        this.datePickerRotaControl.patchValue(auxDate);
      }

      switch (dados.BandeiraCartao) {
        case 'AmericanExpress':
          this.pedidoForm.get('srcImagemCartao').patchValue('./assets/cartoes/american_express.png');
          break;

        case 'Elo':
          this.pedidoForm.get('srcImagemCartao').patchValue('./assets/cartoes/elo_cartao.png');
          break;

        case 'MasterCard':
          this.pedidoForm.get('srcImagemCartao').patchValue('./assets/cartoes/master_card.png');
          break;

        case 'Visa':
          this.pedidoForm.get('srcImagemCartao').patchValue('./assets/cartoes/visa_cartao.png');
          break;
      }



      let auxProdutos = [];
      dados.Produtos.forEach(function (entry) {
        entry.ValorFloat = entry.Valor;
        entry.Valor = entry.Valor.toFixed(2).replace('.', ',');
        auxProdutos.push(entry);
      });

      this.pedidoForm.get('produtos').patchValue(auxProdutos);

      this.aTipoStatus = [];
      setTimeout(() => {
        switch (dados.Status) {
          case 'Confirmado':
            this.stepper.selectedIndex = 0;

            this.aTipoStatus.push({ value: 'Em separação', name: 'Em separação' });
            this.aTipoStatus.push({ value: 'Em rota', name: 'Em rota' });
            this.aTipoStatus.push({ value: 'Entregue', name: 'Entregue' });
            this.pedidoForm.get('statusSelect').patchValue('Em separação');
            break;

          case 'Em separação':
            this.stepper.next();
            this.stepper.selectedIndex = 1;

            this.aTipoStatus.push({ value: 'Em rota', name: 'Em rota' });
            this.aTipoStatus.push({ value: 'Entregue', name: 'Entregue' });
            this.pedidoForm.get('statusSelect').patchValue('Em rota');
            break;

          case 'Em rota':
            this.stepper.next();
            this.stepper.next();
            this.stepper.selectedIndex = 2;

            this.aTipoStatus.push({ value: 'Entregue', name: 'Entregue' });
            this.pedidoForm.get('statusSelect').patchValue('Entregue');
            break;

          case 'Entregue':
            this.stepper.next();
            this.stepper.next();
            this.stepper.next();
            this.stepper.selectedIndex = 3;

            this.aTipoStatus.push({ value: 'Entregue', name: 'Entregue' });
            this.pedidoForm.get('statusSelect').patchValue('Entregue');
            this.pedidoForm.get('statusSelect').disable();
            // setTimeout(() => , 10);
            break;

          case 'Cancelado':
            this.stepper.color = 'warn';
            this.aTipoStatus.push({ value: 'Cancelado', name: 'Cancelado' });
            this.pedidoForm.get('motivoCancelamento').disable();
            this.pedidoForm.get('statusSelect').patchValue('Cancelado');
            this.pedidoForm.get('statusSelect').disable();
        }
      }, 10);

      this.router.navigate(
        [],
        {
          relativeTo: this.activeRoute,
          queryParams: { numeroPedido: dados.ID },
          queryParamsHandling: 'merge', // remove to replace all query params by provided
        });
      //uso do readonly="true"
      // this.pedidoForm.get('bairro').disable();
      // this.pedidoForm.get('bandeiraCartao').disable();
      // this.pedidoForm.get('cep').disable();
      // this.pedidoForm.get('cidade').disable();
      // this.pedidoForm.get('complemento').disable();
      // this.pedidoForm.get('email').disable();
      // this.pedidoForm.get('nomeVendedor').disable();
      // this.pedidoForm.get('logradouro').disable();
      // this.pedidoForm.get('nome').disable();
      // this.pedidoForm.get('numero').disable();
      // this.pedidoForm.get('observacao').disable();
      // this.pedidoForm.get('referencia').disable();
      // this.pedidoForm.get('status').disable();
      // this.pedidoForm.get('statusPagamento').disable();
      // this.pedidoForm.get('telefone').disable();
      // this.pedidoForm.get('telefoneSecundario').disable();
      // this.pedidoForm.get('total').disable();
      // this.pedidoForm.get('uf').disable();
      // this.pedidoForm.get('valorCentavosString').disable();
      // this.pedidoForm.get('valorRealString').disable();
      // this.pedidoForm.get('data').disable();
      // this.pedidoForm.get('hora').disable();

      this.usuarioService.getNomeVendedor(this.uid, dados.IDVendedor).pipe(take(1)).subscribe(snap => {
        if (snap) {
          this.pedidoForm.get('nomeVendedor').patchValue(snap.payload.val());
        }
      });


      this.usuarioService.getResponsavelCompra(this.uid, dados.IDUsuario).pipe(take(1)).subscribe(snap => {
        if (snap) {
          this.pedidoForm.get('responsavelCompra').patchValue(snap.payload.val());
        }
      });

      setTimeout(() => this.spinner.hide('consultar-pedidos'), 300);
    } else
      this.selection.toggle(dados);
  }

  atualizar() {
    this.spinner.show('default');
    let b = true;
    if (!this.datePickerRotaControl.value) {
      b = false;
      this.toastr.warning('Informe uma data válida para a rota', 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
      setTimeout(() => this.spinner.hide('default'), 500);
    }

    if (b) {
      try {

        this.db.object('Clientes/' + this.uid + '/Pedidos/' + this.f.id.value).query.ref.transaction(valor => {
          if (valor) {
            const auxDate = new Date(this.datePickerRotaControl.value)

            if (this.f.statusSelect.value === 'Em separação') {
              if (valor.Status === 'Confirmado') {
                valor.Status = 'Em separação';
                valor.TimestampPrevisaoRota = auxDate.getTime();
                valor.TimestampSeparacao = firebase.default.database.ServerValue.TIMESTAMP;
                return valor;
              } else {
                this.toastr.error('Este pedido já teve seu status alterado para: ' + valor.Status, 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
                return valor;
              }
            } else
              if (this.f.statusSelect.value === 'Em rota') {
                if (valor.Status === 'Confirmado' || valor.Status === 'Em separação') {
                  valor.Status = 'Em rota';
                  valor.TimestampRota = firebase.default.database.ServerValue.TIMESTAMP;

                  //Trata o pulo de status de pedido
                  valor.TimestampPrevisaoRota = valor.TimestampPrevisaoRota ? valor.TimestampPrevisaoRota : auxDate.getTime();
                  valor.TimestampSeparacao = valor.TimestampSeparacao ? valor.TimestampSeparacao : firebase.default.database.ServerValue.TIMESTAMP;


                  return valor;
                } else {
                  this.toastr.error('Este pedido já teve seu status alterado para: ' + valor.Status, 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
                  return valor;
                }
              } else
                if (this.f.statusSelect.value === 'Entregue') {
                  if (valor.Status === 'Confirmado' || valor.Status === 'Em separação' || valor.Status === 'Em rota') {
                    valor.Status = 'Entregue';
                    valor.TimestampEntregue = firebase.default.database.ServerValue.TIMESTAMP;

                    //Trata o pulo de status de pedido
                    valor.TimestampPrevisaoRota = valor.TimestampPrevisaoRota ? valor.TimestampPrevisaoRota : auxDate.getTime();
                    valor.TimestampRota = valor.TimestampRota ? valor.TimestampRota : firebase.default.database.ServerValue.TIMESTAMP;
                    valor.TimestampSeparacao = valor.TimestampSeparacao ? valor.TimestampSeparacao : firebase.default.database.ServerValue.TIMESTAMP;

                    return valor;
                  } else {
                    this.toastr.error('Este pedido já teve seu status alterado para: ' + valor.Status, 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
                    return valor;
                  }
                }
          }
          return valor;
        }).then(resp => {
          setTimeout(() => {
            this.spinner.hide('default');
            this.toastr.success('Status alterado com sucesso', 'Status', { progressBar: true, positionClass: 'toast-top-center', });
            this.recarregarPagina();
          }, 500);
        });

      } catch (e) {
        console.log(e)
        this.spinner.hide('default');

        this.usuarioService.setLog("Erro no update de pedido: " + this.f.id.value + ' Erro: ' + e, null, this.uid);

        this.toastr.error('Erro ao atualizar o pedido!', 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
        setTimeout(() => {
          this.router.navigate(["/pages/consultar-pedidos"], { queryParams: { numeroPedido: this.f.id.value } });
        }, 500);
      }
    }
  }

  confirmarPagamento() {
    this.spinner.show('default');

    if (confirm('Confirma o pagamento referente ao pedido: ' + this.f.id.value + '?')) {
      try {

        this.db.object('Clientes/' + this.uid + '/Pedidos/' + this.f.id.value).query.ref.transaction(valor => {
          if (valor) {

            if (valor.StatusPagamento === 'Pendente') {
              valor.StatusPagamento = 'Pago';
              valor.TimestampPagamento = firebase.default.database.ServerValue.TIMESTAMP;
              return valor;
            } else {
              this.toastr.error('Este pedido já teve seu status alterado para: ' + valor.Status, 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
              return valor;
            }
          }
          return valor;
        }).then(resp => {
          setTimeout(() => {
            this.spinner.hide('default');
            this.usuarioService.setLog("Pagamento confirmado. Pedido: " + this.f.id.value, null, this.uid);
            this.toastr.success('Status do pagamento alterado com sucesso', 'Status', { progressBar: true, positionClass: 'toast-top-center', });
            this.recarregarPagina();
          }, 500);
        });

      } catch (e) {
        console.log(e)
        this.spinner.hide('default');

        this.usuarioService.setLog("Erro ao alterar o status do pagamento: " + this.f.id.value + ' para: Pago ' + ' Erro: ' + e, null, this.uid);

        this.toastr.error('Erro ao alterar o status do pagamento!', 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
        setTimeout(() => {
          this.router.navigate(["/pages/consultar-pedidos"], { queryParams: { numeroPedido: this.f.id.value } });
        }, 500);
      }
    } else {
      this.spinner.hide('default');
    }
  }

  alterarFormaPagamento() {

    if (this.validaCancelarPedido()) {
      const dialogRef = this.dialog.open(AlterarFormaPagamentoDialog, {
        data: { formaPagamento: this.f.formaPagamento.value, bandeiraCartao: this.f.bandeiraCartao.value, numeroParcelas: this.f.numeroParcelas.value, prazoBoleto: this.f.prazoBoleto.value, prazoNota: this.f.prazoNota.value, total: this.f.total.value },
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          try {
            this.spinner.show('default');

            this.db.object('Clientes/' + this.uid + '/Pedidos/' + this.f.id.value).query.ref.transaction(valor => {
              if (valor) {

                if (valor.Status !== 'Entregue' && valor.Status !== 'Cancelado') {
                  valor.FormaPagamento = result.FormaPagamento;
                  valor.BandeiraCartao = result.BandeiraCartao;
                  valor.NumeroParcelas = result.NumeroParcelas;
                  valor.PrazoBoleto = result.PrazoBoleto;
                  valor.PrazoNota = result.PrazoNota;
                  return valor;
                } else {
                  this.toastr.error('Este pedido já teve seu status alterado para: ' + valor.Status + ' e não foi possível realizar a alteração na forma de pagamento', 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
                  return valor;
                }
              }
              return valor;
            }).then(resp => {
              setTimeout(() => {
                this.spinner.hide('default');
                this.usuarioService.setLog("Pedido: " + this.f.id.value + ' com forma de pagamento alterada para: ' + result.FormaPagamento + ' ' + result.BandeiraCartao + ' ' + result.PrazoBoleto + ' ' + result.NumeroParcelas, null, this.uid);
                this.toastr.success('Forma de pagamento alterada com sucesso', 'Status', { progressBar: true, positionClass: 'toast-top-center', });
                this.recarregarPagina();
              }, 500);
            });

          } catch (e) {
            console.log(e)
            this.spinner.hide('default');

            this.usuarioService.setLog("Erro ao alterar a forma de pagamento: " + this.f.id.value + ' para: ' + result.FormaPagamento + ' ' + result.BandeiraCartao + '. Erro: ' + e, null, this.uid);

            this.toastr.error('Erro ao alterar a forma de pagamento!', 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
            setTimeout(() => {
              this.router.navigate(["/pages/consultar-pedidos"], { queryParams: { numeroPedido: this.f.id.value } });
            }, 500);
          }
        }
      });
    } else {
      this.toastr.error('Você deve cancelar o boleto antes de alterar a forma de pagamento.', 'Status', { progressBar: true, positionClass: 'toast-top-center', });
    }
  }

  retornarStatusPedido() {
    //Retorna o status do pedido para confirmado
    const dialogRef = this.dialog.open(RetornarStatusPedidoDialog);

    dialogRef.afterClosed().subscribe(result => {
      if (result) {

        try {
          this.spinner.show('default');

          let bDebitarValor: boolean = false;

          this.db.object('Clientes/' + this.uid + '/Pedidos/' + this.f.id.value).query.ref.transaction(valor => {
            if (valor) {

              //Trava removida para conclusão de pedidos em boleto que foram pagos em dinheiro
              // if (this.bRemoverProdutosCancelarPedido && valor.Status !== 'Cancelado') {
              if (valor.Status !== 'Cancelado') {
                valor.Status = 'Confirmado';

                if (valor.StatusPagamento === 'Cancelado' || valor.StatusPagamento === 'Pago') {
                  valor.StatusPagamento = 'Pendente';
                  bDebitarValor = true;
                }
                valor.StatusRetornado = true;
                valor.TimestampRetornoStatus = firebase.default.database.ServerValue.TIMESTAMP;


                return valor;
              } else {
                this.toastr.error('Este pedido já teve seu status alterado para: ' + valor.Status + ' e não foi possível retornar o status para confirmado.', 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
                return valor;
              }
            }
            return valor;
          }).then(async resp => {

            let respEstorno;
            if (bDebitarValor) {
              this.toastr.warning('Debitando o saldo do cliente...', 'Status', { progressBar: true, positionClass: 'toast-top-center', });

              respEstorno = await this.db.object('Clientes/' + this.uid + '/Usuarios/' + this.f.idUsuario.value + '/CreditoDisponivel').query.ref.transaction(saldo => {
                if (saldo) {
                  saldo -= this.f.total.value;
                  return saldo;
                }
                return saldo;
              });
            }

            setTimeout(() => {
              this.spinner.hide('default');
              this.usuarioService.setLog("Pedido: " + this.f.id.value + ' STATUS RETORNADO PARA "CONFIRMADO". Saldo debitado: ' + bDebitarValor, null, this.uid);
              if (respEstorno && bDebitarValor) {
                this.toastr.success('Status retornado com sucesso e saldo debitado.', 'Status', { progressBar: true, positionClass: 'toast-top-center', });
              } else {
                if (!bDebitarValor) {
                  this.toastr.success('Status retornado com sucesso.', 'Status', { progressBar: true, positionClass: 'toast-top-center', });
                } else
                  this.toastr.warning('O status foi retornado, porém houve um erro ao debitar o saldo do cliente. Faça uma conferência manual!', 'Status', { progressBar: true, positionClass: 'toast-top-center', });
              }

              this.recarregarPagina();
            }, 500);
          });

        } catch (e) {
          console.log(e)
          this.spinner.hide('default');

          this.usuarioService.setLog("Erro ao alterar o status do pagamento: " + this.f.id.value + ' para: Pago ' + ' Erro: ' + e, null, this.uid);

          this.toastr.error('Erro ao alterar o status do pagamento!', 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
          setTimeout(() => {
            this.router.navigate(["/pages/consultar-pedidos"], { queryParams: { numeroPedido: this.f.id.value } });
          }, 500);
        }


      }
    });
  }

  bloquearSelecaoTabela() {
    this.bBloquearClickTabela = !this.bBloquearClickTabela;
    this.iconeCadeado = this.bBloquearClickTabela ? 'lock_open' : 'lock';
  }

  cancelarPedido() {
    if (this.validaCancelarPedido()) {
      const dialogRef = this.dialog.open(CancelarPedidoDialog);
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          try {
            this.spinner.show('default');

            console.log('iniciando transação cancelamento pedido');

            console.log('Clientes/' + this.uid + '/Pedidos/' + this.f.id.value);

            this.db.object('Clientes/' + this.uid + '/Pedidos/' + this.f.id.value).query.ref.transaction(valor => {
              console.log(valor)
              if (valor) {

                if (this.bRemoverProdutosCancelarPedido && valor.Status !== 'Cancelado') {
                  valor.Status = 'Cancelado';
                  valor.StatusPagamento = 'Cancelado';
                  valor.MotivoCancelamento = result;
                  valor.TimestampCancelado = firebase.default.database.ServerValue.TIMESTAMP;
                  return valor;
                } else {
                  this.toastr.error('Este pedido já teve seu status alterado para: ' + valor.Status + ' e não foi possível realizar o cancelamento', 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
                  return valor;
                }
              }
              return valor;
            }).then(async resp => {

              this.toastr.warning('Estornando estoque dos produtos da compra...', 'Status', { progressBar: true, positionClass: 'toast-top-center', });

              const respEstorno = await this.usuarioService.estornarProdutosPedidoCancelado(this.f.id.value);


              setTimeout(() => {
                this.spinner.hide('default');
                this.usuarioService.setLog("Pedido: " + this.f.id.value + ' Cancelado.', null, this.uid);
                if (respEstorno) {
                  this.toastr.success('Pedido cancelado com sucesso', 'Status', { progressBar: true, positionClass: 'toast-top-center', });
                } else {
                  this.toastr.error('O pedido foi cancelado, porém houve um erro ao estornar os produtos. Faça uma conferência manual!', 'Status', { progressBar: true, positionClass: 'toast-top-center', });
                }

                this.recarregarPagina();
              }, 500);
            }).catch((error: any) => {
              console.log(error)
              console.log(error.message)
              this.spinner.hide('default');

              this.usuarioService.setLog("Erro ao cancelar pedido: " + this.f.id.value + ' ' + error, null, this.uid);

              this.toastr.error('Erro ao alterar cancelar o pedido!', 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
              setTimeout(() => {
                this.router.navigate(["/pages/consultar-pedidos"], { queryParams: { numeroPedido: this.f.id.value } });
              }, 500);
            });

          } catch (e) {
            console.log(e)
            this.spinner.hide('default');

            this.usuarioService.setLog("Erro ao cancelar pedido: " + this.f.id.value + ' ' + e, null, this.uid);

            this.toastr.error('Erro ao alterar cancelar o pedido!', 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
            setTimeout(() => {
              this.router.navigate(["/pages/consultar-pedidos"], { queryParams: { numeroPedido: this.f.id.value } });
            }, 500);
          }
        } else {
          this.toastr.warning('É necessário especificar o motivo do cancelamento para prosseguir', 'Status', { progressBar: true, positionClass: 'toast-top-center', });
        }
      });
    } else {
      this.toastr.error('Você deve cancelar o boleto antes de cancelar o pedido.', 'Status', { progressBar: true, positionClass: 'toast-top-center', });
    }
  }

  validaCancelarPedido() {
    if (this.f.formaPagamento.value !== 'Boleto')
      return true;

    if (!this.permitirGerarBoleto(1) && !this.permitirGerarBoleto(2))
      return false;

    return true;
  }

  /** Whether the number of selected elements matches the total number of rows. */
  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.pedidosSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }

    this.selection.select(...this.pedidosSource.data);
  }

  /** The label for the checkbox on the passed row */
  checkboxLabel(row?: any): string {
    if (!row) {
      return `${this.isAllSelected() ? 'deselect' : 'select'} all`;
    }
    return `${this.selection.isSelected(row) ? 'deselect' : 'select'} row ${row.position + 1}`;
  }

  alertConfirmaPagamentoDemanda() {
    const dialogRef = this.dialog.open(AlterarPagamentosDemandaDialog, {
      disableClose: false,
    });
  }

  alertAlterarStatusDemanda() {

    const dados = this.selection.selected;

    const dialogRef = this.dialog.open(AlterarStatusPedidoDemandaDialog, {
      disableClose: false,
      data: { pedidos: dados },
    });
  }

  alertRemoverProdutos() {
    const dialogRef = this.dialog.open(RemoverProdutoDialog, {
      disableClose: true,
      data: { produtos: this.f.produtos.value, total: this.f.total.value, idPedido: this.f.id.value },
    });
  }

  alertTipoImpressao() {
    const dialogRef = this.dialog.open(AlertaTipoImpressaoDialog);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.imprimir(result.tipo);
      }
    });

  }

  imprimirRelatorioVendasClientes() {
    let doc = new jsPDF('l', 'mm', [297, 210]);
    let corpo: any = [];
    const dados = this.selection.selected;
    dados.forEach(dado => {
      var aux = [dado.ID, dado.Data, dado.Bairro, dado.Cidade, dado.Nome, dado.FormaPagamento, dado.StatusPagamento, dado.Status, 'R$ ' + dado.ValorRealString + ',' + dado.ValorCentavosString];
      corpo.push(aux);
    });

    let somatotal = 0;

    for (let i = 0; i < dados.length; i++) {
      somatotal += dados[i].Total;
    }

    autoTable(doc, {
      head: [["Pedido", "Data", "Bairro", "Cidade", "Cliente", "Forma de PGT", "Status PGT", "Status", "Total"]],
      theme: 'grid',
      body: corpo,
      margin: { top: 10, right: 5, bottom: 10, left: 5 },
      showHead: 'firstPage',
      showFoot: 'lastPage',
      foot: [["", "", "", "", "", "", "", "", "Total: R$ " + somatotal.toFixed(2).replace('.', ',')]]
    });

    doc.save('Relatório_Clientes_Pedidos_' + this.usuarioService.tratarData(new Date().getTime()) + '.pdf');

    this.usuarioService.setLog("Exportou relatório de vendas em PDF. Período: " + this.usuarioService.tratarData(new Date(this.range.get('start').value).getTime()) + "_" + this.usuarioService.tratarData(new Date(this.range.get('end').value).getTime()), 'Não é necessário redundância do export', this.uid);
  }

  imprimirProdutos() {
    this.spinner.show('consultar-pedidos');

    let date: Date = new Date();
    let totalIndividualProdutosComprados = [];
    let contTotalProdutosGeral = 0;
    let numerosPedidos = [];
    const dados = this.selection.selected;

    console.log(dados)

    for (let i = 0; i < dados.length; i++) {
      if (dados && dados[i].Status !== 'Cancelado') {
        dados[i].Produtos ? dados[i].Produtos.forEach((item) => {
          const aux: any = item;
          if (!numerosPedidos.includes(dados[i].ID)) {
            numerosPedidos.push(dados[i].ID);
          }

          const index = totalIndividualProdutosComprados.findIndex(x => x.Key === aux.Key);
          index !== -1 ? totalIndividualProdutosComprados[index].QuantidadeComprada = (totalIndividualProdutosComprados[index].QuantidadeComprada + aux.QuantidadeComprada) : totalIndividualProdutosComprados.push({
            Key: aux.Key,
            Codigo: aux.CodigoProduto,
            QuantidadeComprada: aux.QuantidadeComprada,
            Grupo: aux.Grupo,
            Nome: aux.Nome
          });
          contTotalProdutosGeral += aux.QuantidadeComprada;
        }) : null;
      }
    }

    totalIndividualProdutosComprados.sort((a, b) => a.Nome.localeCompare(b.Nome));

    let doc: any = new jsPDF('p', 'mm', [297, 210]);
    let corpo: any = [];
    totalIndividualProdutosComprados.forEach(dado => {
      var aux = [dado.Codigo, dado.Nome, dado.Grupo, dado.QuantidadeComprada];
      corpo.push(aux);
    });

    autoTable(doc, {
      head: [["Codigo", "Produto", "Grupo", "Total"]],
      theme: 'grid',
      body: corpo,
      margin: { top: 10, right: 5, bottom: 10, left: 5 },
      showHead: 'firstPage',
      showFoot: 'lastPage',
      foot: [["", "", "Total: " + contTotalProdutosGeral]]
    });

    let auxNumPedidos = 'Pedidos: ';
    for (let i = 0; i < numerosPedidos.length; i++) {
      auxNumPedidos = auxNumPedidos + numerosPedidos[i] + '; ';
    }

    doc.autoTable({
      theme: 'striped',
      columnStyles: { 0: { halign: 'left' }, },
      body: [[auxNumPedidos]],
      margin: { top: 10, right: 5, bottom: 10, left: 5 },
      startY: doc.previousAutoTable.finalY + 50,
      showHead: 'firstPage',
      showFoot: 'lastPage',
    });

    doc.save('Relatório_Produtos_Pedidos_' + this.usuarioService.tratarData(date.getTime()) + '.pdf');

    setTimeout(() => this.spinner.hide('consultar-pedidos'), 300);
  }

  //Algoritmo Versão 3 com consulta de clientes em uma nova Promisse
  imprimirLoteV3() {
    this.spinner.show('default');
    try {
      this.usuarioService.getDadosEmpresa(this.uid).pipe(take(1)).subscribe(async snap => {
        if (snap) {
          const dadosEmpresa: any = snap;
          //const tamanhoFila: number = this.selection.selected.length - 1;

          if (dadosEmpresa) {
            let windowPopup;
            //Ordena a seleção, evitando falha no primeiro item da impressão;
            let auxArray = this.selection.selected;
            auxArray.sort((a, b) => a.ID - b.ID);
            let primeiroItemArray = '' + auxArray[0].ID;

            this.usuarioService.getFuncionarios(this.uid).pipe(take(1)).subscribe(snap => {
              let vendedores = [];

              if (snap.length > 0) {
                var dados;

                snap.forEach((item, index) => {
                  dados = item.payload.val();
                  if (dados.Status && dados.Permissoes.Vender) {
                    vendedores.push({
                      IDVendedor: item.key,
                      Nome: dados.Nome
                    });
                  }
                });

                let auxAImpressao: any = [];
                let bErro = false;

                const resp = Promise.all(auxArray.map((dadosPedido) => {

                  return new Promise((resolve, reject) => {

                    // this.usuarioService.getClienteByID(this.uid, dadosPedido.IDUsuario).pipe(take(1)).toPromise(); //Se não acionar uma nova Promise, há erro de leitura de memória, fazendo com que haja undefined na impressão (CNPJ / CPF)
                    const resp = this.usuarioService.getClienteByID(dadosPedido.IDUsuario).pipe(take(1)).subscribe((dadosCliente: any) => {
                      if (dadosCliente) {
                        //FUNCIONAL
                        let auxProdutos = '';
                        const produtos = dadosPedido.Produtos;

                        for (let i = 0; i < produtos.length; i++) {
                          if (!produtos[i].DescontoGrupoPromocional) {
                            auxProdutos = auxProdutos +
                              '<tr>' +
                              '<td><div style="display: inline-block">' + produtos[i].CodigoProduto + '</div></td>' +
                              '<td><div style="margin-left: 5px; display: inline-block">' + produtos[i].Nome + '</div></td>' +
                              '<td><div style="margin-left: 10px; display: inline-block">' + produtos[i].QuantidadeComprada + ' ' + this.usuarioService.tratarUnidade(produtos[i].Unidade) + '</div></td>' +
                              '<td><div style="margin-left: 10px; display: inline-block"> R$ ' + produtos[i].Valor.toFixed(2).replace('.', ',') + '</div></td>' +
                              '<td><div style="margin-left: 10px; display: inline-block"> R$ ' + (produtos[i].QuantidadeComprada * produtos[i].Valor).toFixed(2).replace('.', ',') + '</div></td>' +
                              '</tr>'
                          } else {
                            auxProdutos = auxProdutos +
                              '<tr>' +
                              '<td><div style="display: inline-block">' + produtos[i].CodigoProduto + '</div></td>' +
                              '<td><div style="margin-left: 5px; display: inline-block">' + produtos[i].Nome + '<div style="font-size: 10px; display: inline-block"> - ' + produtos[i].NomeGrupoPromocional + ' | ' + produtos[i].PorcentagemDesconto + '% </div></div></td>' +
                              '<td><div style="margin-left: 10px; display: inline-block">' + produtos[i].QuantidadeComprada + ' ' + this.usuarioService.tratarUnidade(produtos[i].Unidade) + '</div></td>' +
                              '<td><div style="margin-left: 10px; display: inline-block"> R$ ' + produtos[i].ValorRealDesconto + ',' + produtos[i].ValorCentavosDesconto + '</div></td>' +
                              '<td><div style="margin-left: 10px; display: inline-block"> R$ ' + (produtos[i].QuantidadeComprada * produtos[i].ValorDesconto).toFixed(2).replace('.', ',') + '</div></td>' +
                              '</tr>'
                          }
                        }

                        const cpfCNPJ = dadosCliente.CPF ? ('<div style="font-weight: 550; display: inline-block; margin-right: 5px;"> CPF: </div>' + dadosCliente.CPF) : ('<div style="font-weight: 550; display: inline-block; margin-right: 5px;"> CNPJ: </div>' + dadosCliente.CNPJ);
                        const voucher = !dadosPedido.ValorDescontoVoucher ? '' : `<div style="font-size: 10px; margin-right: 16px; display: inline-block">Voucher: R$ ${dadosPedido.ValorDescontoVoucher.toFixed(2).replace('.', ',')}</div>`

                        const valorDesconto = !dadosPedido.Desconto ? '' : `<div style="font-size: 10px; margin-right: 16px; display: inline-block">Desconto: R$ ${dadosPedido.Desconto.toFixed(2).replace('.', ',')}</div>`
                        console.log('dadosPedido', dadosPedido)
                        console.log('valorDesconto', valorDesconto)
                        auxAImpressao.push({
                          ID: dadosPedido.ID, CodigoImpressao:
                            //Inicio ROW
                            '<div class="row" ' + (dadosPedido.ID !== primeiroItemArray ? ' style="page-break-before: always;"' : '') + '>' +

                            //HEADER
                            '<div class="col-sm text-center">' +
                            '<table class="minimalistBlack">' +
                            '<thead>' +
                            '<tr>' +
                            '<th colspan="5" style="text-align: center; height: 65px"><img style="width: 70px; position: absolute; margin-top: -5px; margin-left: -100px" src="assets/logo_ipanema.svg">' + dadosEmpresa.RazaoSocial + '<div style="white-space:pre-line"></div>' +
                            '<div style="font-weight: normal; font-size: 12px">Pedido Nº ' + dadosPedido.ID + ' - ' + dadosPedido.Data + ' às ' + dadosPedido.Hora + '</div></th>' +
                            '</tr>' +
                            '</thead>' +
                            //HEADER FIM
                            //RODAPÉ
                            '<tfoot>' +
                            '<tr>' +
                            '<td colspan="5" style="text-align: center">Data: ______/______/______  Valor <div style="white-space:pre-line"></div> <div style="margin-left: -300px; margin-top: 10px"> Assinatura: </div></td>' +
                            '</tr>' +
                            '</tfoot>' +
                            //RODAPÉ FIM
                            '<tbody>' +
                            //LINHA 1
                            '<tr>' +
                            '<td colspan="5"><div style="font-weight: 550; display: inline-block; margin-right: 5px;">Cliente: </div>' + dadosPedido.Nome + ' - ' + dadosPedido.Telefone + '<div style="white-space:pre-line"></div>' +
                            cpfCNPJ +
                            '<div style="white-space:pre-line"></div>' +
                            '<div style="font-weight: 550; display: inline-block; margin-right: 5px;">Endereço: </div>' + dadosPedido.Logradouro + ', ' + dadosPedido.Numero + ', ' + dadosPedido.Bairro + ' - ' + dadosPedido.Cidade + '/' + dadosPedido.UF + '</div>' +
                            '</td>' +
                            '</tr>' +
                            //LINHA 1 FIM
                            //LINHA 2 HEADER
                            '<tr style="font-weight: 700">' +
                            '<td>Cód.</td>' +
                            '<td>Produto</td>' +
                            '<td>Qtde.</td>' +
                            '<td>Valor unitário</td>' +
                            '<td>Subtotal</td>' +
                            '</tr>' +
                            //LINHA 2 HEADER FIM
                            //LINHA 3 LOOP Produtos
                            auxProdutos +
                            //LINHA 3 LOOP Produtos FIM

                            //LINHA TOTAL
                            '<tr>' +
                            '<td colspan="5" style="font-size: 14px; font-weight: 600; text-align: end;">' + voucher + valorDesconto + 'Total: R$ ' + dadosPedido.ValorRealString + ',' + dadosPedido.ValorCentavosString + '</td>' +
                            '</tr>' +
                            //LINHA TOTAL FIM
                            //LINHA FORMA PAGAMENTO
                            '<tr>' +
                            '<td colspan="2" style="font-weight: 600;">  ' + dadosPedido.FormaPagamento +
                            (dadosPedido.FormaPagamento === 'Boleto' ? (dadosPedido.NumeroParcelas === 2 ? ' - 2 boletos (10 e 15 dias)' : (' - ' + dadosPedido.PrazoBoleto) + ' dias') : '') +
                            (dadosPedido.FormaPagamento === 'Nota' ? ' ' + dadosPedido.PrazoNota + ' dia(s)' : '') +
                            '</td>' +
                            '<td colspan="3">' +
                            '<div style="text-align: end;">Data da emissão: ' + this.usuarioService.tratarData(new Date().getTime()) + '</div>' +
                            '</td>' +
                            '</tr>' +
                            //LINHA FORMA PAGAMENTO FIM
                            //LINHA VENDEDOR
                            '<tr>' +
                            '<td colspan="5" style="font-weight: 600;">Vendedor: ' + vendedores[vendedores.findIndex(x => x.IDVendedor === dadosPedido.IDVendedor)].Nome + '</td>' +
                            '</tr>' +
                            //LINHA VENDEDOR FIM
                            //LINHA OBSERVAÇÃO
                            (dadosPedido.Observacao.length > 0 ?
                              ('<tr>' +
                                '<td colspan="5" style="font-weight: 600;">Observação: ' + dadosPedido.Observacao + '</td>' +
                                '</tr>')
                              : ''
                            )
                            +
                            //LINHA OBSERVAÇÃO FIM
                            '</tbody>' +
                            '</table>' +
                            ((dadosPedido.FormaPagamento === 'Nota') ?
                              '<div class="row mt-2">'
                              + '<div class="col-sm">'
                              + '- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -'
                              + '</div>'
                              + '</div>'


                              + '<div class="row mt-2">'
                              + '<div class="col-sm">'

                              + '<table class="minimalistBlack">'
                              // + '<thead>'
                              + '<tr>'
                              // + '<th colspan="5" style="text-align: center; height: 65px"><img style="width: 70px; position: absolute; margin-top: -5px; margin-left: -100px" src="assets/logo_ipanema.svg">' + dadosEmpresa.RazaoSocial + '<div style="white-space:pre-line"></div>'
                              + '<th colspan="5" style="text-align: center; height: 65px">' + dadosEmpresa.RazaoSocial + '<div style="white-space:pre-line"></div>'
                              + '<div style="font-weight: normal; font-size: 12px">Recibo da nota Pedido Nº ' + dadosPedido.ID + ' - ' + dadosPedido.Data + ' às ' + dadosPedido.Hora + '</div></th>'
                              + '</tr>'
                              // + '</thead>'
                              //HEADER FIM
                              //RODAPÉ
                              + '<tfoot>'
                              + '<tr>'
                              + '<td colspan="5" style="text-align: center">Data: ______/______/______  Valor: R$ ' + dadosPedido.ValorRealString + ',' + dadosPedido.ValorCentavosString + '<div style="white-space:pre-line"></div> <div style="margin-left: -450px; margin-top: 10px"> Ass. do recebimento da nota: </div></td>'
                              + '</tr>'
                              + '</tfoot>'
                              + '</table>'

                              + '</div>'
                              + '</div>'


                              // '<tfoot>' +
                              // '<tr>' +
                              // '</tr>' +
                              // '</tfoot>'
                              // + '<div class="col-sm text-center">- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -'
                              //+ '<div style="text-align: center">Data: ______/______/______  Valor <div style="white-space:pre-line"></div> <div style="margin-left: -300px; margin-top: 10px"> Assinatura: </div></div>'
                              : ''
                            )
                            +
                            //Fechamento ROW
                            '</div>' + //Fechamento col-sm
                            '</div>'
                        });

                        resolve(true);
                      }
                      //bErro = true;
                      reject(false);
                    });
                  }).catch(err => { bErro = true; console.log(err); });

                })).finally(() => {
                  if (!bErro) {
                    auxAImpressao.sort((a, b) => a.ID - b.ID);

                    let auxCodigoImpressao = '';
                    for (let i = 0; i < auxAImpressao.length; i++) {
                      auxCodigoImpressao = auxCodigoImpressao + auxAImpressao[i].CodigoImpressao;
                    }

                    windowPopup = window.open('Pedido', '_blank', 'width=1000,height=' + (1000)); //Uma impressão com um único produto, === 320 de altura, a cada produto aumentar 10px
                    windowPopup.document.open();


                    windowPopup.document.write(
                      '<html style="width: auto; margin: 16px">' +
                      '<head><link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC" crossorigin="anonymous"></head>'
                      + '<style>table.minimalistBlack {  border: 2px solid #000000;  width: 100%;  text-align: left;}table.minimalistBlack td, table.minimalistBlack th {  border: 1px solid #000000;  padding: 5px 5px;}table.minimalistBlack tbody td {  font-size: 13px;}table.minimalistBlack thead {    border-bottom: 2px solid #000000;}table.minimalistBlack thead th {  font-size: 15px;  font-weight: bold;  color: #000000;  text-align: center;}table.minimalistBlack tfoot {  font-size: 14px;  font-weight: bold;  color: #000000;  border-top: 2px solid #000000;}table.minimalistBlack tfoot td {  font-size: 14px;}</style>'
                      + '<body>'
                    );

                    windowPopup.document.write(auxCodigoImpressao);

                    windowPopup.document.write(
                      '</body>' +
                      '</html>'
                    );

                    windowPopup.document.close();
                    windowPopup.focus();

                    //console.log(windowPopup.document)
                    setTimeout(() => {
                      this.spinner.hide('default');
                    }, 1200);
                    setTimeout(() => {
                      windowPopup.print();
                    }, 1500);
                  } else {
                    alert('Houve um erro ao processar a requisição, por favor atualize a página e tente novamente!');
                    setTimeout(() => {
                      this.spinner.hide('default');
                    }, 1200);
                  }
                })
              }
            });
          }
        }
      });
    } catch (err) {
      setTimeout(() => { window.alert('Erro desconhecido na impressão.'); this.spinner.hide('default'); }, 800);

    }
  }

  imprimir(tipo) {
    this.usuarioService.getDadosEmpresa(this.uid).pipe(take(1)).subscribe(snap => {
      if (snap) {
        const dadosEmpresa: any = snap;

        if (dadosEmpresa) {
          let windowPopup;
          let auxProdutos = '<div style="font-weight: bold;">';
          const produtos = this.f.produtos.value;

          let auxNomeProduto = '';
          switch (tipo) {
            case 'Resumida':

              this.usuarioService.getClienteByID(this.f.idUsuario.value).pipe(take(1)).subscribe(snap => {
                if (snap) {
                  const dados: any = snap;
                  const cpfCNPJ = dados.CPF ? ('<div style="font-weight: 550; display: inline-block; margin-right: 5px;"> CPF: </div>' + dados.CPF) : ('<div style="font-weight: 550; display: inline-block; margin-right: 5px;"> CNPJ: </div>' + dados.CNPJ);

                  for (let i = 0; i < produtos.length; i++) {
                    // auxNomeProduto = (produtos[i].Nome.length > 25 ? produtos[i].Nome.substring(0, 25) : produtos[i].Nome);
                    auxNomeProduto = produtos[i].Nome;

                    if (!produtos[i].DescontoGrupoPromocional) {
                      auxProdutos = auxProdutos +
                        '<div style="display:  inline-block">' + produtos[i].CodigoProduto + '</div>' +
                        '<div style="margin-left: 5px; display:  inline-block">' + auxNomeProduto + '</div>' +
                        // '<div style="margin-left: ' + (auxNomeProduto.length === 25 ? 10 : (auxNomeProduto.length <= 10 ? 100 : (80 - auxNomeProduto.length))) + '; display:  inline-block">' + produtos[i].QuantidadeComprada + ' ' + this.usuarioService.tratarUnidade(produtos[i].Unidade) + ' x </div>' +
                        '<div style="margin-left: 10px; display:  inline-block">' + produtos[i].QuantidadeComprada + ' ' + this.usuarioService.tratarUnidade(produtos[i].Unidade) + ' x </div>' +
                        '<div style="margin-left: 10px; display:  inline-block"> ' + produtos[i].Valor + '</div>' +
                        '<div style="margin-left: 10px; display:  inline-block"> ' + (produtos[i].QuantidadeComprada * produtos[i].ValorFloat).toFixed(2).replace('.', ',') + '</div>' +
                        '<div style="white-space:pre-line"></div>'
                    } else {
                      auxProdutos = auxProdutos +
                        '<div style="display:  inline-block">' + produtos[i].CodigoProduto + '</div>' +
                        '<div style="margin-left: 5px; display:  inline-block">' + auxNomeProduto + '</div>' +
                        // '<div style="margin-left: ' + (auxNomeProduto.length === 25 ? 10 : (auxNomeProduto.length <= 10 ? 100 : (80 - auxNomeProduto.length))) + '; display:  inline-block">' + produtos[i].QuantidadeComprada + ' ' + this.usuarioService.tratarUnidade(produtos[i].Unidade) + ' x </div>' +
                        '<div style="margin-left: 10px; display:  inline-block">' + produtos[i].QuantidadeComprada + ' ' + this.usuarioService.tratarUnidade(produtos[i].Unidade) + ' x </div>' +
                        '<div style="margin-left: 10px; display:  inline-block"> ' + produtos[i].ValorRealDesconto + ',' + produtos[i].ValorCentavosDesconto + '</div>' +
                        '<div style="margin-left: 10px; display:  inline-block"> ' + (produtos[i].QuantidadeComprada * produtos[i].ValorDesconto).toFixed(2).replace('.', ',') + '</div>' +
                        '<div style="white-space:pre-line"></div>'
                    }
                  }

                  auxProdutos = auxProdutos + '</div>';

                  //FUNCIONAL
                  windowPopup = window.open('Pedido', '_blank', 'width=350,height=' + (320 + (produtos.length * 30))); //Uma impressão com um único produto, === 320 de altura, a cada produto aumentar 10px
                  windowPopup.document.open();

                  windowPopup.document.write(
                    '<html style="width:80mm;">' +
                    '<head><link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC" crossorigin="anonymous">' +
                    // '<body style="font-family: Arial, Helvetica, sans-serif; font-weight: 550">' +
                    '<body style="font-family: Arial;">' + //Arial é a melhor fonte para a impressão
                    '<div class="row mt-2">' +
                    // Imagem logo
                    '<div class="col-auto">' +
                    '<img style="width: 70px; position: absolute; margin-top: 10px" src="assets/logo_ipanema.svg">' +
                    '</div>' +

                    //Header
                    '<div style="margin-left: 40px" class="col-sm text-center">' +
                    '<div style="font-weight: 600; font-size: 16px">' + dadosEmpresa.RazaoSocial + '</div>' + '<div style="white-space:pre-line"></div>' +
                    '<div style="font-size: 14px; text-align: left; margin-left: 35px">' +
                    'CNPJ: ' + dadosEmpresa.CNPJ + ' | IE: ' + dadosEmpresa.InscricaoEstadual + '<div style="white-space:pre-line"></div> ' +
                    dadosEmpresa.Logradouro + ', ' + dadosEmpresa.Numero + ' - ' + dadosEmpresa.Bairro + '<div style="white-space:pre-line"></div>Cep: ' + dadosEmpresa.CEP + ' - ' + dadosEmpresa.Cidade + ' - ' + dadosEmpresa.UF + '<div style="white-space:pre-line"></div>' +
                    'Telefone: ' + dadosEmpresa.Telefone +
                    '</div>' +
                    // Fechamento COLUNA HEADER
                    '</div>' +
                    // Fechamento LINHA HEADER
                    '</div>' +

                    //FISCAL
                    '<div class="row mt-2" style="margin-top: 5px;">' +
                    '<div class="col-sm text-center" style="font-weight: 600; font-size: 14px"  align="center">' +
                    'Não é um documento fiscal' +
                    // Fechamento COLUNA FISCAL
                    '</div>' +
                    // Fechamento LINHA FISCAL
                    '</div>' +

                    //PEDIDO
                    '<div class="row mt-2" style="margin-top: 5px;">' +
                    '<div class="col-sm text-center" style="font-size: 12px; font-weight: bold;">' +
                    'Pedido: ' + this.f.id.value + ' - ' + this.f.data.value + ' às ' + this.f.hora.value +
                    // Fechamento COLUNA PEDIDO
                    '</div>' +
                    // Fechamento LINHA PEDIDO
                    '</div>' +

                    //DADOS CLIENTE
                    '<div class="row mt-2" style="margin-top: 5px;">' +
                    '<div class="col-sm" style="font-size: 14px; font-weight: bold;">' +
                    'Cliente: ' + this.f.nome.value + ' - ' + this.f.logradouro.value + ', ' + this.f.numero.value + ', ' + this.f.bairro.value + ' - ' + this.f.cidade.value + '/' + this.f.uf.value +
                    cpfCNPJ +
                    // Fechamento COLUNA DADOS CLIENTE
                    '</div>' +
                    // Fechamento LINHA DADOS CLIENTE
                    '</div>' +

                    //LEGENDA
                    '<div class="row" style="margin-top: -5px">' +
                    '<div class="col-sm text-center">' +
                    '--------------------------------------------------------' + '<div style="white-space:pre-line"></div>' +
                    '<div style="font-size: 10px; margin-top: -5px; font-weight: bold;">' + '<div style="text-align: left; display:  inline-block">Cód. Prod.</div> <div style="margin-left: 15px; display:  inline-block">Descrição</div> <div style="margin-left: 15px; display:  inline-block">Quantidade</div>        <div style="margin-left: 15px; display:  inline-block">Vlr.Unit.</div>       <div style="margin-left: 15px; display:  inline-block">Vlr.Total</div>' + '</div><div style="white-space:pre-line"></div>' +
                    '<div style="margin-top: -5px">--------------------------------------------------------</div>' +
                    // Fechamento COLUNA LEGENDA
                    '</div>' +
                    // Fechamento LINHA LEGENDA
                    '</div>' +

                    //PRODUTOS
                    '<div class="row">' +
                    '<div class="col-sm" style="font-size: 14px; margin-left: 10px;">' +
                    auxProdutos +
                    // Fechamento COLUNA PRODUTOS
                    '</div>' +
                    // Fechamento LINHA PRODUTOS
                    '</div>' +

                    //RODAPE
                    '<div class="row" style="margin-top: -5px">' +
                    '<div class="col-sm">' +
                    '--------------------------------------------------------' + '<div style="white-space:pre-line"></div>' +
                    '<div style="font-size: 14px; margin-left: 10px; font-weight: bold;">' +
                    'Qtd. Total de Itens: ' + produtos.length + '<div style="white-space:pre-line"></div>' +
                    'Forma de pagamento: ' + this.f.formaPagamento.value +
                    (this.f.formaPagamento.value === 'Boleto' ? (this.f.numeroParcelas.value === 2 ? ' - 2 boletos (10 e 15 dias)' : (' - ' + this.f.prazoBoleto.value) + ' dias') : '') +
                    (this.f.formaPagamento.value === 'Nota' ? ' ' + this.f.prazoNota.value + ' dia(s)' : '') +
                    '<div style="white-space:pre-line"></div>' +
                    (!this.f.valorDescontoVoucher.value ? '' : '<div style="font-size: 12px; font-weight: 700; display:  inline-block">Voucher: R$ ' + this.f.valorDescontoVoucher.value.toFixed(2).replace('.', ',') + '</div><div style="white-space:pre-line"></div>') +
                    (!this.f.valorDesconto.value ? '' : '<div style="font-size: 12px; font-weight: 700; display:  inline-block">Desconto: R$ ' + this.f.valorDesconto.value.toFixed(2).replace('.', ',') + '</div><div style="white-space:pre-line"></div>') +
                    'Total: <div style="font-weight: 700; display:  inline-block">R$ ' + this.f.valorRealString.value + ',' + this.f.valorCentavosString.value + '</div><div style="white-space:pre-line"></div>' +
                    // Fechamento STYLE RODAPE
                    '</div>' +
                    // Fechamento COLUNA RODAPE
                    '</div>' +
                    // Fechamento LINHA RODAPE
                    '</div>' +

                    //ASSINATURA
                    '<div class="row mt-4">' +
                    '<div class="col-sm text-center">' +

                    '_________________________________' +

                    '<div>Ass. cliente</div>' +

                    //Fechamento COLUNA ASSINATURA
                    '</div>' +
                    //Fechamento LINHA ASSINATURA
                    '</div>' +

                    '</body>' +
                    '</html>');

                  windowPopup.document.close();
                  windowPopup.focus();
                  setTimeout(() => windowPopup.print(), 400);
                }
              });
              break;

            case 'Completa':
              for (let i = 0; i < produtos.length; i++) {
                if (!produtos[i].DescontoGrupoPromocional) {
                  auxProdutos = auxProdutos +
                    '<tr>' +
                    '<td><div style="display: inline-block">' + produtos[i].CodigoProduto + '</div></td>' +
                    '<td><div style="margin-left: 5px; display: inline-block">' + produtos[i].Nome + '</div></td>' +
                    '<td><div style="margin-left: 10px; display: inline-block">' + produtos[i].QuantidadeComprada + ' ' + this.usuarioService.tratarUnidade(produtos[i].Unidade) + '</div></td>' +
                    '<td><div style="margin-left: 10px; display: inline-block"> R$ ' + produtos[i].Valor + '</div></td>' +
                    '<td><div style="margin-left: 10px; display: inline-block"> R$ ' + (produtos[i].QuantidadeComprada * produtos[i].ValorFloat).toFixed(2).replace('.', ',') + '</div></td>' +
                    '</tr>'
                } else {
                  auxProdutos = auxProdutos +
                    '<tr>' +
                    '<td><div style="display: inline-block">' + produtos[i].CodigoProduto + '</div></td>' +
                    '<td><div style="margin-left: 5px; display: inline-block">' + produtos[i].Nome + '<div style="font-size: 10px; display: inline-block"> - ' + produtos[i].NomeGrupoPromocional + ' | ' + produtos[i].PorcentagemDesconto + '% </div></div></td>' +
                    '<td><div style="margin-left: 10px; display: inline-block">' + produtos[i].QuantidadeComprada + ' ' + this.usuarioService.tratarUnidade(produtos[i].Unidade) + '</div></td>' +
                    '<td><div style="margin-left: 10px; display: inline-block"> R$ ' + produtos[i].ValorRealDesconto + ',' + produtos[i].ValorCentavosDesconto + '</div></td>' +
                    '<td><div style="margin-left: 10px; display: inline-block"> R$ ' + (produtos[i].QuantidadeComprada * produtos[i].ValorDesconto).toFixed(2).replace('.', ',') + '</div></td>' +
                    '</tr>'
                }
              }

              //FUNCIONAL
              windowPopup = window.open('Pedido', '_blank', 'width=1000,height=' + (320 + (produtos.length * 30))); //Uma impressão com um único produto, === 320 de altura, a cada produto aumentar 10px
              windowPopup.document.open();

              this.usuarioService.getClienteByID(this.f.idUsuario.value).pipe(take(1)).subscribe(snap => {
                if (snap) {
                  const dados: any = snap;
                  const cpfCNPJ = dados.CPF ? ('<div style="font-weight: 550; display: inline-block; margin-right: 5px;"> CPF: </div>' + dados.CPF) : ('<div style="font-weight: 550; display: inline-block; margin-right: 5px;"> CNPJ: </div>' + dados.CNPJ);

                  const voucher = !this.f.valorDescontoVoucher.value ? '' : `<div style="font-size: 10px; margin-right: 16px; display: inline-block">Voucher: R$ ${this.f.valorDescontoVoucher.value.toFixed(2).replace('.', ',')}</div>`

                  const valorDesconto = !this.f.valorDesconto.value ? '' : `<div style="font-size: 10px; margin-right: 16px; display: inline-block">Desconto: R$ ${this.f.valorDesconto.value.toFixed(2).replace('.', ',')}</div>`

                  console.log('valorDesconto', valorDesconto)

                  windowPopup.document.write(
                    '<html style="width: auto; margin: 16px">' +
                    '<head><link href="https://cdn.jsdelivr.net/npm/bootstrap@5.0.2/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-EVSTQN3/azprG1Anm3QDgpJLIm9Nao0Yz1ztcQTwFspd3yD65VohhpuuCOmLASjC" crossorigin="anonymous">' +
                    '<style>table.minimalistBlack {  border: 2px solid #000000;  width: 100%;  text-align: left;}table.minimalistBlack td, table.minimalistBlack th {  border: 1px solid #000000;  padding: 5px 5px;}table.minimalistBlack tbody td {  font-size: 13px;}table.minimalistBlack thead {    border-bottom: 2px solid #000000;}table.minimalistBlack thead th {  font-size: 15px;  font-weight: bold;  color: #000000;  text-align: center;}table.minimalistBlack tfoot {  font-size: 14px;  font-weight: bold;  color: #000000;  border-top: 2px solid #000000;}table.minimalistBlack tfoot td {  font-size: 14px;}</style>' +
                    '<body>' +
                    //Inicio ROW
                    '<div class="row mt-2">' +

                    //HEADER
                    '<div class="col-sm text-center">' +
                    '<table class="minimalistBlack">' +
                    '<thead>' +
                    '<tr>' +
                    '<th colspan="5" style="text-align: center; height: 65px"><img style="width: 70px; position: absolute; margin-top: -5px; margin-left: -100px" src="assets/logo_ipanema.svg">' + dadosEmpresa.RazaoSocial + '<div style="white-space:pre-line"></div>' +
                    '<div style="font-weight: normal; font-size: 12px">Pedido Nº ' + this.f.id.value + ' - ' + this.f.data.value + ' às ' + this.f.hora.value + '</div></th>' +
                    '</tr>' +
                    '</thead>' +
                    //HEADER FIM
                    //RODAPÉ
                    '<tfoot>' +
                    '<tr>' +
                    '<td colspan="5" style="text-align: center">Data: ______/______/______  Valor <div style="white-space:pre-line"></div> <div style="margin-left: -300px; margin-top: 10px"> Assinatura: </div></td>' +
                    '</tr>' +
                    '</tfoot>' +
                    //RODAPÉ FIM
                    '<tbody>' +
                    //LINHA 1
                    '<tr>' +
                    '<td colspan="5"><div style="font-weight: 550; display: inline-block; margin-right: 5px;">Cliente: </div>' + this.f.nome.value + ' - ' + this.f.telefone.value + '<div style="white-space:pre-line"></div>' +
                    cpfCNPJ +
                    '<div style="white-space:pre-line"></div>' +
                    '<div style="font-weight: 550; display: inline-block; margin-right: 5px;">Endereço: </div>' + this.f.logradouro.value + ', ' + this.f.numero.value + ', ' + this.f.bairro.value + ' - ' + this.f.cidade.value + '/' + this.f.uf.value + '</div>' +
                    '</td>' +
                    '</tr>' +
                    //LINHA 1 FIM
                    //LINHA 2 HEADER
                    '<tr style="font-weight: 700">' +
                    '<td>Cód.</td>' +
                    '<td>Produto</td>' +
                    '<td>Qtde.</td>' +
                    '<td>Valor unitário</td>' +
                    '<td>Subtotal</td>' +
                    '</tr>' +
                    //LINHA 2 HEADER FIM
                    //LINHA 3 LOOP Produtos
                    auxProdutos +
                    //LINHA 3 LOOP Produtos FIM

                    //LINHA TOTAL
                    '<tr>' +
                    '<td colspan="5" style="font-size: 14px; font-weight: 600; text-align: end;">' + voucher + valorDesconto + ' Total: R$ ' + this.f.valorRealString.value + ',' + this.f.valorCentavosString.value + '</td>' +
                    '</tr>' +
                    //LINHA TOTAL FIM
                    //LINHA FORMA PAGAMENTO
                    '<tr>' +
                    '<td colspan="2" style="font-weight: 600;">Forma de pagamento: ' + this.f.formaPagamento.value +
                    (this.f.formaPagamento.value === 'Boleto' ? (this.f.numeroParcelas.value === 2 ? ' - 2 boletos (10 e 15 dias)' : (' - ' + this.f.prazoBoleto.value) + ' dias') : '') +
                    (this.f.formaPagamento.value === 'Nota' ? ' ' + this.f.prazoNota.value + ' dia(s)' : '') +
                    '</td>' +
                    '<td colspan="3">' +
                    '<div style="text-align: end;">Data da emissão: ' + this.usuarioService.tratarData(new Date().getTime()) + '</div>' +
                    '</td>' +
                    '</tr>' +
                    //LINHA FORMA PAGAMENTO FIM
                    //LINHA VENDEDOR
                    '<tr>' +
                    '<td colspan="5" style="font-weight: 600;">Vendedor: ' + this.f.nomeVendedor.value + '</td>' +
                    '</tr>' +
                    //LINHA VENDEDOR FIM
                    '</tbody>' +
                    '</table>' +

                    (this.f.observacao.value.length > 0 ?
                      ('<tr>' +
                        '<td colspan="5" style="font-weight: 600;">Observação: ' + this.f.observacao.value + '</td>' +
                        '</tr>')
                      : ''
                    )
                    +
                    //LINHA OBSERVAÇÃO FIM
                    '</tbody>' +
                    '</table>' +
                    ((this.f.formaPagamento.value === 'Nota') ?
                      '<div class="row mt-2">'
                      + '<div class="col-sm">'
                      + '- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -'
                      + '</div>'
                      + '</div>'


                      + '<div class="row mt-2">'
                      + '<div class="col-sm">'

                      + '<table class="minimalistBlack">'
                      // + '<thead>'
                      + '<tr>'
                      // + '<th colspan="5" style="text-align: center; height: 65px"><img style="width: 70px; position: absolute; margin-top: -5px; margin-left: -100px" src="assets/logo_ipanema.svg">' + dadosEmpresa.RazaoSocial + '<div style="white-space:pre-line"></div>'
                      + '<th colspan="5" style="text-align: center; height: 65px">' + dadosEmpresa.RazaoSocial + '<div style="white-space:pre-line"></div>'
                      + '<div style="font-weight: normal; font-size: 12px">Recibo da nota Pedido Nº ' + this.f.id.value + ' - ' + this.f.data.value + ' às ' + this.f.hora.value + '</div></th>'
                      + '</tr>'
                      // + '</thead>'
                      //HEADER FIM
                      //RODAPÉ
                      + '<tfoot>'
                      + '<tr>'
                      + '<td colspan="5" style="text-align: center">Data: ______/______/______  Valor: R$ ' + this.f.valorRealString.value + ',' + this.f.valorCentavosString.value + '<div style="white-space:pre-line"></div> <div style="margin-left: -450px; margin-top: 10px"> Ass. do recebimento da nota: </div></td>'
                      + '</tr>'
                      + '</tfoot>'
                      + '</table>'

                      + '</div>'
                      + '</div>' : '') +
                    //Fechamento ROW
                    '</div>' +
                    '</body>' +
                    '</html>');

                  windowPopup.document.close();
                  windowPopup.focus();
                  setTimeout(() => windowPopup.print(), 200);

                }
              });
              break;
          }
        }
      }
    });
  }

  paginatorEvent(event) {
    localStorage.setItem('pageIndex', event.pageIndex);
  }

  filtrarSelect() {
    let filterValue = '';

    switch (this.sTipoBusca) {
      case 'Período':
        filterValue = filterValue + (this.sBuscaStatusPedido !== 'Todos' ? this.sBuscaStatusPedido.trim().toLowerCase() : '');
        filterValue = filterValue + (this.sBuscaStatusPagamento !== 'Todas' ? this.sBuscaStatusPagamento.trim().toLowerCase() : '');
        filterValue = filterValue + (this.sBuscaCidade !== 'Todas' ? this.sBuscaCidade.trim().toLowerCase() : '');
        break;

      case 'Rota':
        const auxPoligonos = JSON.parse(this.aRotas[this.aRotas.findIndex(v => v.idPoligono === this.sBuscaIDPoligono)].poligonos);
        this.poligonoSelecionado = [];
        Object.keys(auxPoligonos).forEach((keyPolygon, index) => {
          this.poligonoSelecionado.push([auxPoligonos[keyPolygon].lat, auxPoligonos[keyPolygon].lng]);
        });
        break;
    }

    filterValue.length > 0 ? this.pedidosSource.filter = filterValue : this.pedidosSource.filter = '';

    if (this.pedidosSource.paginator) {
      this.pedidosSource.paginator.firstPage();
    }
  }

  changeSelect() {
    this.sTipoBusca === 'IDPedido' ? setTimeout(() => document.getElementById('numeroPedido').focus(), 100) : null;
    if (this.sTipoBusca === 'Período') {
      this.maxDate.getTime() >= new Date().getTime() ? this.range.get('end').patchValue(new Date()) : null;
      this.maxDate = new Date(); // Soma 3 semanas a frente;
    } else {
      this.maxDate = new Date(new Date().getTime() + 1814400000);
    }

    localStorage.setItem('tipoBuscaSelect', '' + this.sTipoBusca);
  }

  aplicarFiltroTabela(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.pedidosSource.filter = filterValue.trim().toLowerCase();

    if (this.pedidosSource.paginator) {
      this.pedidosSource.paginator.firstPage();
    }
  }

  visualizarMapaCliente() {
    const dialogRef = this.dialog.open(MapaLatlngClienteDialog, {
      data: { latitude: this.f.latitude.value, longitude: this.f.longitude.value },
    });
  }

  voltar() {
    this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
      this.router.navigate(["/pages/consultar-pedidos"]));
  }

  imprimirTipo() {
    switch (this.sTipoImpressao) {
      case 'Lista produtos':
        this.imprimirProdutos();
        break;

      case 'Lote':
        this.imprimirLoteV3()
        break;

      case 'Relação pedidos':
        this.imprimirRelatorioVendasClientes();
        break;

      case 'Boletos':
        this.imprimirSomenteBoletos();
        break;

      case 'Canhotos recibos':
        this.imprimirCanhotosRecibos();
        break;
    }
  }

  // convenience getter for easy access to form fields
  get f() { return this.pedidoForm.controls; }

  //#region Boletos
  imprimirCanhotosRecibos() {
    const dados = this.selection.selected;

    const dialogRef = this.dialog.open(GerarCanhotosDialog, {
      disableClose: false,
      data: { pedidos: dados.filter((x: PedidoConsultaElement) => x.FormaPagamento === 'Boleto') },
    });
  }

  imprimirSomenteBoletos() {
    let pdfsBase64: string[] = new Array();
    const dados = this.selection.selected;

    for (let i = 0; i < dados.length; i++) {
      if (dados && dados[i].Status !== 'Cancelado' && dados[i].PDFbase64) {
        pdfsBase64.push(dados[i].PDFbase64);
        if (dados[i].PDFbase64Parcela2)
          pdfsBase64.push(dados[i].PDFbase64Parcela2);
      }
    }

    this.sicoobService.imprimirBoletos(pdfsBase64, null);
  }

  alertGerarBoletoDemanda() {

    const dados = this.selection.selected;

    const dialogRef = this.dialog.open(GerarBoletoDemandaDialog, {
      disableClose: false,
      data: { pedidos: dados },
    });
  }

  permitirGerarBoleto(parcela: number) {
    if (this.f.formaPagamento.value === 'Boleto' && this.f.statusPagamento.value === 'Pendente') {
      if (parcela === 1 && this.f.pdfBase64?.value === undefined) {
        return true;
      }
      if (parcela === 2 && this.f.numeroParcelas?.value === 2 && this.f.pdfBase64Parcela2?.value === undefined) {
        return true;
      }
    }

    return false;
  }

  gerarBoleto(parcela: number) {
    const dialogRef = this.dialog.open(GerarBoletoDialog, {
      data: { valor: this.f.total.value, timestampPedido: this.f.timestamp.value, prazoBoleto: this.f.prazoBoleto.value },
    });
    dialogRef.afterClosed().subscribe(async result => {
      if (result) {
        try {
          this.spinner.show('default');
          this.pedidoSelecionado.Total = result.valor;
          this.pedidoSelecionado.ObservacaoBoleto = result.observacao;

          this.tokenSicoob = {
            access_token: '',
            statusCode: 0,
            dataSolicitacao: null
          };
          this.tokenSicoob = await this.sicoobService.retornaTokenValidado(this.tokenSicoob);

          await this.sicoobService.gerarBoletoPedido(this.pedidoSelecionado, new Date(result.dataVencimento), parcela, this.tokenSicoob.access_token).then(((resp: StatusGerarBoleto) => {
            setTimeout(() => {
              if (resp.Status)
                this.toastr.success('Boleto gerado com sucesso', 'Status', { progressBar: true, positionClass: 'toast-top-center', });
              else
                this.toastr.error(`Erro ao gerar boleto. Erro: ${resp.Erro}`, 'Status', { progressBar: true, positionClass: 'toast-top-center', timeOut: 5000 });

              this.recarregarPagina();
              this.spinner.hide('default');
            }, 1500);
          }));
        } catch (error) {
          console.log(error);
          this.erroGerarBoleto(error);
        }
      }
    });
  }

  async cancelarBoleto(parcela: number) {
    const dialogRef = this.dialog.open(CancelarBoletoDialog);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        try {
          this.spinner.show('default');
          const idBoleto = parcela === 1 ? this.f.idBoleto.value : this.f.idBoleto2.value;
          this.usuarioService.getBoleto(idBoleto).pipe(take(1)).subscribe(async snap => {
            if (snap) {
              const dados: ConsultaBoleto = snap as ConsultaBoleto;

              this.sicoobService.cancelarBoleto(gerarMapBoletoBaixa(dados), (await this.sicoobService.retornaTokenValidado(this.tokenSicoob)).access_token).subscribe(
                (resp: any) => {
                  console.log(resp)
                  if (resp.success) {
                    let mapPedido;

                    if (parcela === 1)
                      mapPedido = {
                        PDFbase64: null,
                        SituacaoBoleto: 'Baixado',
                        StatusBoleto: 'Cancelado'
                      };
                    else
                      mapPedido = {
                        PDFbase64Parcela2: null,
                        SituacaoBoleto: 'Baixado',
                        StatusBoleto: 'Cancelado'
                      };

                    const mapBoleto = {
                      SituacaoBoleto: 'Baixado',
                      Status: 'Cancelado'
                    };

                    this.usuarioService.updateBoletoPedido(this.f.id.value, mapPedido);
                    this.usuarioService.updateStatusBoleto(idBoleto, mapBoleto);
                    this.finalizarCancelarBoleto(true, '');
                  } else {
                    this.finalizarCancelarBoleto(false, 'Houve um erro ao cancelar o boleto');
                  }
                },
                (error: any) => {

                  console.log(error);
                }
              ).add(() => {

              });
            }
          });
        } catch (error) {
          console.log(error);
          this.erroGerarBoleto(error);
        }
      }
    });
  }

  finalizarCancelarBoleto(bStatus: boolean, mensagem: string) {
    if (bStatus) {
      this.toastr.success(`Boleto cancelado com sucesso!`, 'Status', { progressBar: true, positionClass: 'toast-top-center', timeOut: 5000 });
      this.usuarioService.setLog(`Boleto do pedido: ${this.f.id.value}' cancelado com sucesso.`, null, this.uid);
    } else {
      this.toastr.error(`Erro ao cancelar o boleto. Erro: ${mensagem}`, 'Status', { progressBar: true, positionClass: 'toast-top-center', timeOut: 5000 });
      this.usuarioService.setLog(`Erro ao gerar cancelar o boleto do pedido: ${this.f.id.value}'. Erro: ${mensagem}`, null, this.uid);
      this.spinner.hide('default');
    }

    setTimeout(() => {
      this.spinner.hide('default');
      this.recarregarPagina();
    }, 300);
  }

  recarregarPagina() {
    this.router.navigateByUrl('/pages/refresh', { skipLocationChange: true }).then(() =>
      this.router.navigate(["/pages/consultar-pedidos"], { queryParams: { numeroPedido: this.f.id.value } }));
  }

  erroGerarBoleto(error: any) {
    this.usuarioService.setLog("Erro ao gerar boleto para o pedido: " + this.f.id.value + '. Erro: ' + error, null, this.uid);
    this.toastr.error(`Erro ao gerar boleto. Erro: ${error}`, 'Erro', { progressBar: true, positionClass: 'toast-top-center', });
    setTimeout(() => {
      this.router.navigate(["/pages/consultar-pedidos"], { queryParams: { numeroPedido: this.f.id.value } });
    }, 100);
    this.spinner.hide('default');
  }

  imprimirBoleto(parcela: number) {
    this.sicoobService.imprimirBoletos(new Array(parcela === 1 ? this.f.pdfBase64.value : this.f.pdfBase64Parcela2.value), `Boleto pedido: ${this.f.id.value}`);
  }
  //#endregion
}
